// Cities BBox
export const CitiesBBox = {
  "city-kozhikode":
    "75.7153808877278,11.135954220698475,75.84617526198834,11.349441315767068",
  "city-hubli":
    "75.02630830465863,15.314320281538041,75.18991498422217,15.416945925619784",
  "city-vijayawada":
    "80.55483741934115,16.457323424796137,80.73474837224367,16.559859865723602",
};

// kozhikodePoints
const kozhikodePoints = [
  [11.385798, 75.761984, 3],
  [11.222627, 75.851226, 3],
  [11.2684925, 75.805431, 9],
  [11.416136, 75.930327, 14],
  [11.1903283, 75.8283187, 20],
  [11.361555, 75.805668, 21],
  [11.64382973, 75.85705555, 32],
  [11.366899, 76.009577, 34],
  [11.1758247, 75.8259974, 35],
  [11.3042939, 75.801491, 41],
  [11.338404, 75.741484, 43],
  [11.304617, 75.874706, 46],
  [11.385798, 75.761984, 55.556],
  [11.684126, 75.677546, 56],
  [11.1903283, 75.8283187, 61],
  [11.420913, 75.832455, 62],
  [11.1903283, 75.8283187, 83],
  [11.2584085, 75.7856626, 92],
  [11.444647, 75.693532, 93.75],
  [11.254665, 75.793685, 103],
  [11.60429, 75.586583, 120],
  [11.304617, 75.874706, 137],
  [11.361555, 75.805668, 138],
  [11.4863, 76.01291, 139],
  [11.2684925, 75.805431, 139],
  [11.2597885121259, 75.8353494590702, 150],
  [11.272498, 75.841218, 165],
  [11.319819, 75.799663, 179],
  [11.2860705, 75.843111, 180],
  [11.272498, 75.841218, 184],
  [11.60429, 75.586583, 185.8],
  [11.222627, 75.851226, 191],
  [11.2627699, 75.935808, 197],
  [11.450643, 75.758145, 204],
  [11.416136, 75.930327, 215],
  [11.60429, 75.586583, 230],
  [11.2684925, 75.805431, 230],
  [11.6769303, 75.7789151, 248],
  [11.2627275, 75.7755057, 250],
  [11.3218152, 75.9903399, 253],
  [11.246999, 75.784122, 253],
  [11.60429, 75.586583, 268],
  [11.416136, 75.930327, 276],
  [11.254665, 75.793685, 298],
  [11.349764, 75.7605, 306],
  [11.304617, 75.874706, 312],
  [11.215765, 75.798993, 321],
  [11.659993, 75.748157, 344],
  [11.293908, 75.912659, 344],
  [11.66941915, 75.6290057, 352],
  [11.3807243, 75.7236207, 400],
  [11.416136, 75.930327, 400],
  [11.320934, 75.846647, 402],
  [11.2597885121259, 75.8353494590702, 426],
  [11.319819, 75.799663, 431],
  [11.3209424, 75.7505575, 444],
  [11.293908, 75.912659, 459],
  [11.304617, 75.874706, 459],
  [11.304617, 75.874706, 486],
  [11.3218152, 75.9903399, 497],
  [11.304617, 75.874706, 517],
  [11.175347, 75.807355, 522],
  [11.175347, 75.807355, 556],
  [11.272498, 75.841218, 574],
  [11.287949, 75.871331, 574],
  [11.25248, 75.82043, 600],
  [11.43997337, 75.82399547, 643],
  [11.2882115, 75.7535662, 650],
  [11.60429, 75.586583, 689],
  [11.444647, 75.693532, 689],
  [11.1758247, 75.8259974, 689],
  [11.366899, 76.009577, 689],
  [11.316724, 75.976601, 689],
  [11.60429, 75.586583, 765],
  [11.320934, 75.846647, 765],
  [11.245362, 75.806879, 765],
  [11.294542, 75.850003, 785],
  [11.48091, 75.99992, 803],
  [11.60429, 75.586583, 804],
  [11.295799, 75.823342, 804],
  [11.2643175, 75.88568, 804],
  [11.247549, 75.842158, 861],
  [11.517559, 75.621824, 872],
  [11.2882115, 75.7535662, 918],
  [11.304617, 75.874706, 918],
  [11.305519, 75.763455, 918],
  [11.2597885121259, 75.8353494590702, 960],
  [11.272498, 75.841218, 977],
  [11.444647, 75.693532, 1000],
  [11.245362, 75.806879, 1000],
  [11.444647, 75.693532, 1000],
  [11.223089, 75.831974, 1002],
  [11.333956, 75.773033, 1033],
  [11.292949, 75.792429, 1147],
  [11.222627, 75.851226, 1148],
  [11.222627, 75.851226, 1148],
  [11.2860705, 75.843111, 1148],
  [11.338404, 75.741484, 1148],
  [11.222627, 75.851226, 1148],
  [11.187052, 75.871537, 1148],
  [11.1758247, 75.8259974, 1161],
  [11.223089, 75.831974, 1167],
  [11.25248, 75.82043, 1200],
  [11.25248, 75.82043, 1200],
  [11.2684925, 75.805431, 1200],
  [11.3042939, 75.801491, 1205],
  [11.305519, 75.763455, 1205],
  [11.187052, 75.871537, 1248],
  [11.2802589, 75.7819622, 1288],
  [11.2860705, 75.843111, 1332],
  [11.321888, 75.941362, 1333],
  [11.235371, 75.791213, 1341],
  [11.247549, 75.842158, 1345],
  [11.367828, 75.771569, 1359],
  [11.367828, 75.771569, 1359],
  [11.222627, 75.851226, 1377],
  [11.292166, 75.772881, 1378],
  [11.60429, 75.586583, 1378],
  [11.2884609, 75.803135, 1476],
  [11.517559, 75.621824, 1492],
  [11.297888, 75.833138, 1492],
  [11.2706963, 75.789311, 1500],
  [11.27729, 75.810049, 1500],
  [11.6769303, 75.7789151, 1500],
  [11.246999, 75.784122, 1546],
  [11.270947, 75.837413, 1561],
  [11.222627, 75.851226, 1574],
  [11.3218152, 75.9903399, 1607],
  [11.272498, 75.841218, 1607],
  [11.30939777, 75.77818314, 1607],
  [11.293908, 75.912659, 1658],
  [11.27729, 75.810049, 1688],
  [11.60429, 75.586583, 1720],
  [11.245362, 75.806879, 1750],
  [11.2627699, 75.935808, 1799],
  [11.334544, 75.763779, 1800],
  [11.2701322, 75.8302778, 1815],
  [11.3218152, 75.9903399, 1837],
  [11.272498, 75.841218, 1837],
  [11.295799, 75.823342, 1837],
  [11.2261194, 75.7960977, 1837],
  [11.294542, 75.850003, 1894],
  [11.225719, 75.793969, 1894],
  [11.299372, 75.860372, 1906],
  [11.292166, 75.772881, 1907],
  [11.299372, 75.860372, 1913],
  [11.564987, 75.762653, 1928.571],
  [11.30939777, 75.77818314, 1939],
  [11.2802589, 75.7819622, 1952],
  [11.444647, 75.693532, 2000],
  [11.175347, 75.807355, 2009],
  [11.288877, 75.7850955, 2066],
  [11.60429, 75.586583, 2087],
  [11.2802589, 75.7819622, 2104.348],
  [11.2802589, 75.7819622, 2104.348],
  [11.2802589, 75.7819622, 2104.348],
  [11.2701322, 75.8302778, 2210],
  [11.3042939, 75.7873067, 2250],
  [11.3042939, 75.7873067, 2273],
  [11.3042939, 75.7873067, 2273],
  [11.3042939, 75.7873067, 2273],
  [11.3042939, 75.7873067, 2273],
  [11.2860705, 75.843111, 2296],
  [11.439076, 75.818293, 2296],
  [11.2684925, 75.805431, 2296],
  [11.27729, 75.810049, 2296],
  [11.309673, 75.755487, 2296],
  [11.288877, 75.7850955, 2296],
  [11.269074, 75.792765, 2296],
  [11.2684925, 75.805431, 2381],
  [11.2673673, 75.7621688, 2411],
  [11.1758247, 75.8259974, 2467],
  [11.2627699, 75.935808, 2500],
  [11.2597885121259, 75.8353494590702, 2526],
  [11.2701322, 75.8302778, 2551],
  [11.1903283, 75.8283187, 2551],
  [11.25163, 75.81881, 2568],
  [11.264869, 75.788008, 2571],
  [11.264869, 75.788008, 2571],
  [11.305519, 75.763455, 2640],
  [11.175347, 75.807355, 2650],
  [11.287949, 75.871331, 2650],
  [11.27729, 75.810049, 2667],
  [11.2584085, 75.7856626, 2747],
  [11.2584085, 75.7856626, 2747],
  [11.2684925, 75.805431, 2755],
  [11.2882115, 75.7535662, 2755],
  [11.225719, 75.793969, 2755],
  [11.36721, 75.862965, 2800],
  [11.319819, 75.799663, 2826],
  [11.240993, 75.7895115, 2857],
  [11.28409, 75.78101, 2870],
  [11.2722899, 75.8159578, 2872],
  [11.2643175, 75.88568, 2917],
  [11.2627699, 75.935808, 2923],
  [11.2701322, 75.8302778, 2927],
  [11.43997337, 75.82399547, 2931],
  [11.3042939, 75.7873067, 2947],
  [11.3042939, 75.7873067, 2955],
  [11.254665, 75.793685, 2973],
  [11.254665, 75.793685, 2984],
  [11.2684925, 75.805431, 2985],
  [11.2722899, 75.8159578, 2985],
  [11.306577, 75.82276, 2999],
  [11.240993, 75.7895115, 2999],
  [11.30459278, 75.83434863, 3056],
  [11.2882115, 75.7535662, 3061],
  [11.227806, 75.810045, 3077],
  [11.254665, 75.793685, 3131],
  [11.416136, 75.930327, 3157],
  [11.4960259, 75.8112925, 3188],
  [11.207694, 75.794994, 3200],
  [11.2730489, 75.7757937, 3214],
  [11.272498, 75.841218, 3214],
  [11.220705, 75.797595, 3263],
  [11.402735, 75.727172, 3267],
  [11.2884609, 75.803135, 3333],
  [11.220705, 75.797595, 3395],
  [11.304617, 75.874706, 3398],
  [11.2730489, 75.7757937, 3444],
  [11.175347, 75.807355, 3455],
  [11.293908, 75.912659, 3492],
  [11.2706963, 75.789311, 3500],
  [11.222627, 75.851226, 3500],
  [11.2261194, 75.7960977, 3500],
  [11.2882115, 75.7535662, 3538],
  [11.2627699, 75.935808, 3556],
  [11.175347, 75.807355, 3636],
  [11.175347, 75.807355, 3636],
  [11.175347, 75.807355, 3636],
  [11.175347, 75.807355, 3636],
  [11.245362, 75.806879, 3674],
  [11.235371, 75.791213, 3674],
  [11.272498, 75.841218, 3696],
  [11.175347, 75.807355, 3750],
  [11.2684925, 75.805431, 3750],
  [11.247549, 75.842158, 3800],
  [11.2884609, 75.803135, 3826],
  [11.254665, 75.793685, 3827],
  [11.3042939, 75.801491, 3828],
  [11.2860705, 75.843111, 3831],
  [11.276616, 75.890307, 3878],
  [11.416136, 75.930327, 3903],
  [11.223089, 75.831974, 3903],
  [11.305519, 75.763455, 3966],
  [11.297888, 75.833138, 4000],
  [11.19841135, 75.86726707, 4000],
  [11.304617, 75.874706, 4000],
  [11.306577, 75.82276, 4000],
  [11.245362, 75.806879, 4000],
  [11.26998, 75.78076, 4062],
  [11.245362, 75.806879, 4071],
  [11.304617, 75.874706, 4091],
  [11.19841135, 75.86726707, 4133],
  [11.2730489, 75.7757937, 4133],
  [11.272498, 75.841218, 4167],
  [11.2884609, 75.803135, 4167],
  [11.238144, 75.812459, 4174],
  [11.238144, 75.812459, 4174],
  [11.238144, 75.812459, 4174],
  [11.238144, 75.812459, 4174],
  [11.238144, 75.812459, 4174],
  [11.238144, 75.812459, 4175],
  [11.238144, 75.812459, 4175],
  [11.238144, 75.812459, 4175],
  [11.238144, 75.812459, 4175],
  [11.3218152, 75.9903399, 4180],
  [11.3042939, 75.801491, 4182],
  [11.297888, 75.833138, 4195],
  [11.297888, 75.833138, 4195],
  [11.297888, 75.833138, 4195],
  [11.297888, 75.833138, 4195],
  [11.309673, 75.755487, 4209],
  [11.222627, 75.851226, 4273],
  [11.222627, 75.851226, 4301],
  [11.225719, 75.793969, 4319],
  [11.294542, 75.850003, 4333],
  [11.254665, 75.793685, 4337],
  [11.2261194, 75.7960977, 4364],
  [11.272498, 75.841218, 4375],
  [11.295864, 75.814257, 4397],
  [11.175347, 75.807355, 4400],
  [11.292166, 75.772881, 4444],
  [11.245362, 75.806879, 4455],
  [11.292949, 75.792429, 4474],
  [11.240993, 75.7895115, 4480],
  [11.2884609, 75.803135, 4500],
  [11.3042939, 75.7873067, 4500],
  [11.247549, 75.842158, 4533],
  [11.247549, 75.842158, 4533],
  [11.247549, 75.842158, 4533],
  [11.2706963, 75.789311, 4579],
  [11.2389, 75.80161, 4583],
  [11.292166, 75.772881, 4591],
  [11.26392, 75.79471, 4591],
  [11.2684925, 75.805431, 4592],
  [11.2584085, 75.7856626, 4592],
  [11.2584085, 75.7856626, 4592],
  [11.235371, 75.791213, 4592],
  [11.2884609, 75.803135, 4592],
  [11.2261194, 75.7960977, 4592],
  [11.25248, 75.82043, 4615],
  [11.270947, 75.837413, 4667],
  [11.444647, 75.693532, 4667],
  [11.2884609, 75.803135, 4700],
  [11.2884609, 75.803135, 4700],
  [11.2884609, 75.803135, 4700],
  [11.2884609, 75.803135, 4700],
  [11.2884609, 75.803135, 4700],
  [11.295864, 75.814257, 4722],
  [11.305519, 75.763455, 4800],
  [11.2802589, 75.7819622, 4831],
  [11.2673673, 75.7621688, 5000],
  [11.235371, 75.791213, 5000],
  [11.238144, 75.812459, 5000],
  [11.26392, 75.79471, 5000],
  [11.225719, 75.793969, 5026],
  [11.258945, 75.781036, 5057],
  [11.222627, 75.851226, 5062],
  [11.187052, 75.871537, 5152],
  [11.27729, 75.810049, 5158],
  [11.295799, 75.823342, 5188],
  [11.28712, 75.79542, 5198],
  [11.2597885121259, 75.8353494590702, 5263],
  [11.2882115, 75.7535662, 5312],
  [11.272498, 75.841218, 5385],
  [11.2884609, 75.803135, 5417],
  [11.2884609, 75.803135, 5417],
  [11.2884609, 75.803135, 5417],
  [11.222627, 75.851226, 5455],
  [11.305519, 75.763455, 5500],
  [11.543637, 75.840402, 5500],
  [11.2884609, 75.803135, 5556],
  [11.175347, 75.807355, 5556],
  [11.264869, 75.788008, 5571],
  [11.295799, 75.823342, 5625],
  [11.26998, 75.78076, 5655],
  [11.2261194, 75.7960977, 5667],
  [11.175347, 75.807355, 5714],
  [11.215765, 75.798993, 5740],
  [11.2730489, 75.7757937, 5740],
  [11.292949, 75.792429, 5745],
  [11.444647, 75.693532, 5767],
  [11.25337, 75.8010331, 5789],
  [11.25248, 75.82043, 5800],
  [11.2884609, 75.803135, 5926],
  [11.2802589, 75.7819622, 5952],
  [11.25337, 75.8010331, 5963],
  [11.258945, 75.781036, 6000],
  [11.2802589, 75.7819622, 6000],
  [11.2584085, 75.7856626, 6000],
  [11.2584085, 75.7856626, 6000],
  [11.2701322, 75.8302778, 6000],
  [11.2701322, 75.8302778, 6000],
  [11.2701322, 75.8302778, 6000],
  [11.1758247, 75.8259974, 6000],
  [11.2701322, 75.8302778, 6061],
  [11.2701322, 75.8302778, 6061],
  [11.2701322, 75.8302778, 6061],
  [11.247549, 75.842158, 6107],
  [11.269476, 75.780974, 6198],
  [11.416136, 75.930327, 6207],
  [11.295799, 75.823342, 6250],
  [11.245362, 75.806879, 6286],
  [11.2684925, 75.805431, 6360],
  [11.292166, 75.772881, 6373],
  [11.288877, 75.7850955, 6401],
  [11.2684925, 75.805431, 6438],
  [11.2706963, 75.789311, 6449],
  [11.25566, 75.77729, 6464.15],
  [11.2597885121259, 75.8353494590702, 6471],
  [11.2597885121259, 75.8353494590702, 6471],
  [11.2597885121259, 75.8353494590702, 6471],
  [11.2597885121259, 75.8353494590702, 6471],
  [11.2597885121259, 75.8353494590702, 6471],
  [11.2597885121259, 75.8353494590702, 6471],
  [11.2597885121259, 75.8353494590702, 6471],
  [11.247549, 75.842158, 6475],
  [11.247549, 75.842158, 6475],
  [11.247549, 75.842158, 6475],
  [11.2684925, 75.805431, 6500],
  [11.25337, 75.8010331, 6533],
  [11.247549, 75.842158, 6720],
  [11.247549, 75.842158, 6720],
  [11.247549, 75.842158, 6720],
  [11.2684925, 75.805431, 6723],
  [11.247549, 75.842158, 6754],
  [11.2684925, 75.805431, 6800],
  [11.48091, 75.99992, 6833],
  [11.2706963, 75.789311, 6836],
  [11.245362, 75.806879, 6887],
  [11.25566, 75.77729, 6888],
  [11.292949, 75.792429, 6958],
  [11.292949, 75.792429, 6958],
  [11.238144, 75.812459, 6979],
  [11.2261194, 75.7960977, 7000],
  [11.269476, 75.780974, 7018],
  [11.2884609, 75.803135, 7083],
  [11.2884609, 75.803135, 7083],
  [11.2884609, 75.803135, 7083],
  [11.2884609, 75.803135, 7083],
  [11.247549, 75.842158, 7107],
  [11.236215, 75.824825, 7192],
  [11.236215, 75.824825, 7192],
  [11.236215, 75.824825, 7192],
  [11.269074, 75.792765, 7213],
  [11.270947, 75.837413, 7249],
  [11.564987, 75.762653, 7411],
  [11.2722899, 75.8159578, 7472],
  [11.292166, 75.772881, 7500],
  [11.2261194, 75.7960977, 7500],
  [11.2722899, 75.8159578, 7533],
  [11.264869, 75.788008, 7605],
  [11.2802589, 75.7819622, 7609],
  [11.246999, 75.784122, 7692],
  [11.236215, 75.824825, 7742],
  [11.247549, 75.842158, 7750],
  [11.295799, 75.823342, 7750],
  [11.240993, 75.7895115, 7759],
  [11.2722899, 75.8159578, 7868],
  [11.222627, 75.851226, 7885],
  [11.2684925, 75.805431, 7925],
  [11.258945, 75.781036, 7954],
  [11.258945, 75.781036, 7954],
  [11.258945, 75.781036, 7954],
  [11.2882115, 75.7535662, 8000],
  [11.2882115, 75.7535662, 8000],
  [11.2882115, 75.7535662, 8000],
  [11.2882115, 75.7535662, 8000],
  [11.2684925, 75.805431, 8000],
  [11.416136, 75.930327, 8000],
  [11.2882115, 75.7535662, 8039],
  [11.2882115, 75.7535662, 8039],
  [11.2882115, 75.7535662, 8039],
  [11.263193, 75.873601, 8106],
  [11.222627, 75.851226, 8118],
  [11.2882115, 75.7535662, 8197],
  [11.27729, 75.810049, 8223],
  [11.263193, 75.873601, 8315],
  [11.263193, 75.873601, 8315],
  [11.263193, 75.873601, 8315],
  [11.305519, 75.763455, 8411],
  [11.2730489, 75.7757937, 8451],
  [11.247549, 75.842158, 8551],
  [11.247549, 75.842158, 8551],
  [11.247549, 75.842158, 8551],
  [11.2802589, 75.7819622, 8571],
  [11.222627, 75.851226, 8571],
  [11.2884609, 75.803135, 8824],
  [11.36721, 75.862965, 8896],
  [11.2882115, 75.7535662, 8920],
  [11.2627699, 75.935808, 9053],
  [11.2597885121259, 75.8353494590702, 9167],
  [11.254329, 75.816168, 9215],
  [11.2882115, 75.7535662, 9403],
  [11.2882115, 75.7535662, 9403],
  [11.2882115, 75.7535662, 9403],
  [11.2722899, 75.8159578, 9412],
  [11.2882115, 75.7535662, 9500],
  [11.2684925, 75.805431, 9600],
  [11.2882115, 75.7535662, 9836],
  [11.2884609, 75.803135, 9863],
  [11.2884609, 75.803135, 9863],
  [11.2884609, 75.803135, 9863],
  [11.263193, 75.873601, 9945],
  [11.3218152, 75.9903399, 10000],
  [11.292949, 75.792429, 10000],
  [11.292949, 75.792429, 10000],
  [11.2261194, 75.7960977, 10000],
  [11.2673673, 75.7621688, 10383],
  [11.272498, 75.841218, 10520],
  [11.2389, 75.80161, 10600],
  [11.258326, 75.77767, 10714],
  [11.25566, 75.77729, 10901],
  [11.2584085, 75.7856626, 12000],
  [11.450643, 75.758145, 12500],
  [11.263193, 75.873601, 13108],
  [11.263193, 75.873601, 13108],
  [11.263193, 75.873601, 13108],
  [11.222627, 75.851226, 15385],
  [11.215765, 75.798993, 15417],
  [11.269476, 75.780974, 16667],
  [11.246999, 75.784122, 16667],
  [11.361555, 75.805668, 17220],
  [11.2730489, 75.7757937, 18000],
  [11.222627, 75.851226, 18889],
  [11.266469, 75.836102, 20000],
  [11.266469, 75.836102, 20000],
  [11.306577, 75.82276, 20000],
  [11.238144, 75.812459, 20087],
  [11.2684925, 75.805431, 23077],
  [11.253576, 75.787018, 23333],
  [11.2467, 75.82871, 23913],
  [11.2684925, 75.805431, 30154],
  [11.247549, 75.842158, 30555],
  [11.247549, 75.842158, 30555],
  [11.247549, 75.842158, 30555],
  [11.247549, 75.842158, 30555],
  [11.336328, 76.111157, 32000],
];

// HubliPoints
const hubliPoints = [
  [15.3778724, 75.1153405, 24],
  [15.3495782, 75.14074076, 35],
  [15.372433, 75.159951, 185],
  [15.356085, 75.036101, 230],
  [15.317016, 75.146409, 344],
  [15.3509578, 75.0714372, 370],
  [15.21188, 75.12962, 459],
  [15.3458359, 75.0913411, 498],
  [15.3509578, 75.0714372, 521],
  [15.345068, 75.14278, 574],
  [15.350812, 75.108256, 599],
  [15.3558347, 75.1162922, 689],
  [15.3558347, 75.1162922, 689],
  [15.371329, 75.104754, 689],
  [15.32716, 75.14978, 704],
  [15.361313, 75.110314, 938],
  [15.370373, 75.152199, 1000],
  [15.372433, 75.159951, 1000],
  [15.32716, 75.14978, 1042],
  [15.36055, 75.1439922, 1250],
  [15.372433, 75.159951, 1250],
  [22.9012432730676, 88.3894882538196, 1259],
  [15.399718, 75.070857, 1394],
  [15.350812, 75.108256, 1399],
  [15.32162474, 75.12904295, 1415],
  [15.399718, 75.070857, 1500],
  [15.3954368, 75.0701932, 1515],
  [15.350812, 75.108256, 1692],
  [15.350812, 75.108256, 1699],
  [15.3509578, 75.0714372, 1699],
  [15.381723, 75.077071, 1750],
  [15.3407728, 75.1033145, 1750],
  [15.3407728, 75.1033145, 1783],
  [15.350812, 75.108256, 1800],
  [15.386761, 75.166081, 1800],
  [15.3483393601606, 75.1340865315987, 1810],
  [15.399718, 75.070857, 1833],
  [15.408002, 75.062311, 1858],
  [15.372433, 75.159951, 1882],
  [15.386761, 75.166081, 1897],
  [15.372433, 75.159951, 1904],
  [15.3248915, 75.1169365, 1912],
  [15.36055, 75.1439922, 1917],
  [15.3509578, 75.0714372, 1979],
  [15.3954368, 75.0701932, 2182],
  [15.372433, 75.159951, 2200],
  [15.398999, 75.083366, 2204],
  [15.3778724, 75.1153405, 2296],
  [15.37348062, 75.16096983, 2333],
  [15.345979, 75.147925, 2400],
  [15.361313, 75.110314, 2400],
  [15.381723, 75.077071, 2401],
  [15.3778724, 75.1153405, 2455],
  [15.3954368, 75.0701932, 2581],
  [15.3778724, 75.1153405, 2604],
  [15.398999, 75.083366, 2610],
  [15.3554445, 75.1337967, 2667],
  [15.399595, 75.081524, 2667],
  [15.398999, 75.083366, 2733],
  [15.386761, 75.166081, 2755],
  [15.35775897, 75.14754253, 2759],
  [15.3954368, 75.0701932, 2800],
  [15.3954368, 75.0701932, 2874],
  [15.3554445, 75.1337967, 2875],
  [15.398999, 75.083366, 2882],
  [15.3554445, 75.1337967, 2909],
  [15.3954368, 75.0701932, 2917],
  [15.398999, 75.083366, 2973],
  [15.386761, 75.166081, 2975],
  [15.3483393601606, 75.1340865315987, 2986],
  [15.386761, 75.166081, 2997],
  [15.3954368, 75.0701932, 3000],
  [15.366098, 75.139882, 3000],
  [15.3248915, 75.1169365, 3000],
  [15.317016, 75.146409, 3000],
  [15.361313, 75.110314, 3000],
  [15.356808, 75.157092, 3056],
  [15.36055, 75.1439922, 3159],
  [15.371883, 75.155311, 3238],
  [15.356808, 75.157092, 3250],
  [15.371883, 75.155311, 3315],
  [15.350812, 75.108256, 3333],
  [15.372433, 75.159951, 3396],
  [15.381723, 75.077071, 3438],
  [15.3407728, 75.1033145, 3467],
  [15.3747331, 75.1115473, 3500],
  [15.368098, 75.131373, 3500],
  [15.366098, 75.139882, 3500],
  [15.3954368, 75.0701932, 3500],
  [15.36055, 75.1439922, 3500],
  [15.3483393601606, 75.1340865315987, 3529],
  [15.3554445, 75.1337967, 3571],
  [15.3558347, 75.1162922, 3600],
  [15.3558347, 75.1162922, 3600],
  [15.364491, 75.137279, 3636],
  [15.3509578, 75.0714372, 3700],
  [15.368098, 75.131373, 3702],
  [15.356808, 75.157092, 3713],
  [15.356808, 75.157092, 3750],
  [15.370373, 75.152199, 3750],
  [15.361313, 75.110314, 3754],
  [15.368098, 75.131373, 3800],
  [15.386761, 75.166081, 3801],
  [15.372433, 75.159951, 3818],
  [15.350812, 75.108256, 3889],
  [15.368098, 75.131373, 3913],
  [15.361313, 75.110314, 3966],
  [15.36055, 75.1439922, 3991],
  [15.3248915, 75.1169365, 4000],
  [15.36055, 75.1439922, 4143],
  [15.361313, 75.110314, 4163],
  [15.366098, 75.139882, 4274],
  [15.386761, 75.166081, 4343],
  [15.356768, 75.090023, 4375],
  [15.347242, 75.129348, 4429],
  [15.368098, 75.131373, 4450],
  [15.3407728, 75.1033145, 4462],
  [15.386761, 75.166081, 4499],
  [15.3554445, 75.1337967, 4500],
  [15.3248915, 75.1169365, 4545],
  [15.21188, 75.12962, 4583],
  [15.366098, 75.139882, 4762],
  [15.36447, 75.155182, 4800],
  [15.35775897, 75.14754253, 4800],
  [15.386761, 75.166081, 4800],
  [15.36055, 75.1439922, 4804],
  [15.3954368, 75.0701932, 4835],
  [15.351483, 75.096417, 4884],
  [15.35012, 75.10372, 5000],
  [15.371883, 75.155311, 5000],
  [15.37335357, 75.11179046, 5000],
  [15.371883, 75.155311, 5078],
  [15.368098, 75.131373, 5083],
  [15.3778724, 75.1153405, 5125],
  [15.36055, 75.1439922, 5152],
  [15.36055, 75.1439922, 5152],
  [15.371883, 75.155311, 5170],
  [15.3558347, 75.1162922, 5217],
  [15.356808, 75.157092, 5333],
  [15.36055, 75.1439922, 5405],
  [15.36055, 75.1439922, 5417],
  [15.372433, 75.159951, 5429],
  [22.8642257, 88.3662465, 5455],
  [15.371883, 75.155311, 5500],
  [15.367389, 75.105083, 5573],
  [15.36055, 75.1439922, 5594],
  [15.362335, 75.161637, 5678],
  [15.35775897, 75.14754253, 5705],
  [15.345068, 75.14278, 5714],
  [15.35711172, 75.15465318, 5769],
  [15.350812, 75.108256, 5879],
  [15.3448, 75.1077862, 6000],
  [15.34091324, 75.13060962, 6000],
  [15.350812, 75.108256, 6010],
  [15.345068, 75.14278, 6111],
  [15.361313, 75.110314, 6194],
  [15.3602495, 75.12468892, 6200],
  [15.361313, 75.110314, 6351],
  [15.366098, 75.139882, 6486],
  [15.368098, 75.131373, 6667],
  [15.3596516, 75.0980052, 6667],
  [15.36055, 75.1439922, 6667],
  [15.3778724, 75.1153405, 6875],
  [15.3248915, 75.1169365, 6875],
  [15.350812, 75.108256, 6981],
  [15.35775897, 75.14754253, 7000],
  [15.3954368, 75.0701932, 7143],
  [15.362335, 75.161637, 7154],
  [15.332432, 75.135565, 7222],
  [15.350812, 75.108256, 7292],
  [15.3407728, 75.1033145, 7333],
  [15.326733, 75.128409, 7407],
  [15.350812, 75.108256, 7723],
  [15.38884989, 75.10428083, 7745],
  [15.3778724, 75.1153405, 7778],
  [15.368098, 75.131373, 7812],
  [15.350812, 75.108256, 7833],
  [15.368098, 75.131373, 7837],
  [15.366098, 75.139882, 7927],
  [15.368917, 75.151773, 7997],
  [15.345979, 75.147925, 8095],
  [15.361313, 75.110314, 8250],
  [15.36055, 75.1439922, 8333],
  [15.3602495, 75.12468892, 8667],
  [15.350812, 75.108256, 8667],
  [15.35707, 75.08777, 8750],
  [15.3954368, 75.0701932, 8800],
  [15.362335, 75.161637, 8872],
  [15.340472, 75.142165, 9202],
  [15.35775897, 75.14754253, 9500],
  [15.3448, 75.1077862, 9958],
  [15.386761, 75.166081, 10000],
  [15.350812, 75.108256, 10000],
  [15.332432, 75.135565, 10000],
  [15.36055, 75.1439922, 10000],
  [15.383446, 75.1201, 10000],
  [15.350812, 75.108256, 10075],
  [15.361313, 75.110314, 10278],
  [15.3558347, 75.1162922, 10393],
  [15.36055, 75.1439922, 10500],
  [15.36055, 75.1439922, 11500],
  [15.368098, 75.131373, 12000],
  [15.3554445, 75.1337967, 12225],
  [15.36055, 75.1439922, 12500],
  [15.3954368, 75.0701932, 13571],
  [15.350812, 75.108256, 14118],
  [15.831882, 74.507161, 14634],
  [15.3483393601606, 75.1340865315987, 14865],
  [15.350812, 75.108256, 15236],
  [15.345774, 75.135467, 15789],
  [15.368098, 75.131373, 16421],
  [15.3554445, 75.1337967, 20000],
  [15.346237, 75.145186, 21429],
  [15.348005, 75.145473, 24306],
  [15.3558347, 75.1162922, 30000],
  [15.381723, 75.077071, 34444],
  [15.350812, 75.108256, 41109],
  [15.3407728, 75.1033145, 200000],
  [15.4484992, 75.203594, 1250000],
];

// vijayawadaPoints
const vijayawadaPoints = [
  [16.5714134, 80.6818557, 9],
  [16.5061743, 80.6480153, 17],
  [16.56340779, 80.62326548, 18],
  [16.5714134, 80.6818557, 19],
  [16.5005173, 80.6621701, 32],
  [16.4905671, 80.6923312, 32],
  [16.5061743, 80.6480153, 34],
  [16.527059, 80.598294, 36],
  [16.367497, 80.843539, 46],
  [16.4944613, 80.6652908, 50],
  [16.5286537, 80.6313041, 53],
  [16.4944613, 80.6652908, 69],
  [16.4267618, 80.5774534, 71],
  [16.367497, 80.843539, 83],
  [16.5061743, 80.6480153, 86],
  [16.483373, 80.6618234, 90],
  [16.474876, 80.605606, 90],
  [16.6837219, 80.3955449, 100],
  [16.36818, 80.98712, 117],
  [16.638506, 80.970529, 119],
  [16.367497, 80.843539, 127],
  [16.6837219, 80.3955449, 143],
  [16.5061743, 80.6480153, 182],
  [16.5061743, 80.6480153, 191],
  [16.4267618, 80.5774534, 200],
  [16.568618, 80.545502, 207],
  [16.638506, 80.970529, 230],
  [16.5283487, 80.7941356, 247],
  [16.367497, 80.843539, 257],
  [16.367497, 80.843539, 259],
  [16.7730685, 80.267503, 261],
  [16.5061743, 80.6480153, 267],
  [16.5061743, 80.6480153, 278],
  [16.7730685, 80.267503, 278],
  [17.0084792, 80.3759106, 287],
  [16.7730685, 80.267503, 326],
  [16.46816, 80.719534, 333],
  [16.7730685, 80.267503, 344],
  [16.44275729, 80.77378856, 344],
  [16.538803, 80.64017066, 358],
  [16.512538, 80.726716, 367],
  [16.6837219, 80.3955449, 373],
  [16.499589, 80.677748, 437],
  [16.4977172305877, 80.6545350343677, 443],
  [16.5489578, 80.5966093, 444],
  [16.5283487, 80.7941356, 444],
  [16.5836552, 80.6153262, 444],
  [16.5061743, 80.6480153, 444],
  [16.658464, 80.409004, 444],
  [16.5489578, 80.5966093, 444],
  [16.5311839, 80.638935, 444],
  [16.658464, 80.409004, 444],
  [16.5025858, 80.7111025, 444],
  [16.658464, 80.409004, 444],
  [16.4216986, 80.7538462, 446],
  [16.5061743, 80.6480153, 446],
  [16.5061743, 80.6480153, 446],
  [16.5836552, 80.6153262, 446],
  [16.5836552, 80.6153262, 446],
  [16.5836552, 80.6153262, 446],
  [16.658464, 80.409004, 446],
  [16.38849, 80.80774, 446],
  [16.5061743, 80.6480153, 446],
  [16.4216986, 80.7538462, 446],
  [16.5061743, 80.6480153, 446],
  [16.5061743, 80.6480153, 447],
  [16.5061743, 80.6480153, 448],
  [16.5061743, 80.6480153, 448],
  [16.533109, 80.6007734, 450],
  [16.5061743, 80.6480153, 451],
  [16.6837219, 80.3955449, 459],
  [16.4903251002766, 80.6711626845324, 489],
  [16.437719, 80.740414, 520],
  [16.5283487, 80.7941356, 528],
  [16.5714134, 80.6818557, 556],
  [16.6837219, 80.3955449, 556],
  [16.322985, 80.961208, 556],
  [16.437719, 80.740414, 556],
  [16.5283487, 80.7941356, 556],
  [16.658464, 80.409004, 564],
  [16.46816, 80.719534, 588],
  [16.5061743, 80.6480153, 604],
  [16.5105301, 80.7477708, 612],
  [16.6837219, 80.3955449, 627],
  [16.5283487, 80.7941356, 650],
  [16.5714134, 80.6818557, 651],
  [16.583068, 80.8920773, 667],
  [16.36818, 80.98712, 669],
  [16.5105301, 80.7477708, 689],
  [17.0084792, 80.3759106, 689],
  [17.0084792, 80.3759106, 722],
  [16.523425, 80.775476, 735],
  [16.5283487, 80.7941356, 741],
  [16.322985, 80.961208, 741],
  [16.6837219, 80.3955449, 741],
  [16.5283487, 80.7941356, 741],
  [16.512848, 80.701085, 746],
  [16.5195944, 80.6875634, 766],
  [16.5714134, 80.6818557, 778],
  [16.5714134, 80.6818557, 778],
  [16.322985, 80.961208, 801],
  [16.322985, 80.961208, 804],
  [16.5283487, 80.7941356, 833],
  [16.5283487, 80.7941356, 835],
  [17.0084792, 80.3759106, 875],
  [16.7730685, 80.267503, 889],
  [16.4337801, 80.7678633, 889],
  [16.6837219, 80.3955449, 889],
  [16.638506, 80.970529, 889],
  [16.533109, 80.6007734, 918],
  [16.5714134, 80.6818557, 920],
  [17.0084792, 80.3759106, 926],
  [16.5283487, 80.7941356, 963],
  [16.5061743, 80.6480153, 997],
  [16.5061743, 80.6480153, 1000],
  [16.5061743, 80.6480153, 1049],
  [16.5061743, 80.6480153, 1068],
  [16.4216986, 80.7538462, 1077],
  [16.6837219, 80.3955449, 1079],
  [16.5283487, 80.7941356, 1089],
  [16.4337801, 80.7678633, 1111],
  [16.5283487, 80.7941356, 1111],
  [16.6837219, 80.3955449, 1111],
  [16.5283487, 80.7941356, 1111],
  [16.4337801, 80.7678633, 1111],
  [16.884957, 80.160679, 1111],
  [16.5061743, 80.6480153, 1111],
  [16.52602, 80.80703, 1111],
  [16.898517, 80.103184, 1111],
  [16.658464, 80.409004, 1111],
  [16.4821909, 80.7006496, 1111],
  [16.5283487, 80.7941356, 1111],
  [16.601845, 80.892065, 1111],
  [16.322985, 80.961208, 1111],
  [16.5061743, 80.6480153, 1148],
  [16.638506, 80.970529, 1148],
  [16.5889686, 80.521422, 1148],
  [16.638506, 80.970529, 1164],
  [16.367497, 80.843539, 1168],
  [16.367497, 80.843539, 1185],
  [16.6837219, 80.3955449, 1187],
  [16.38849, 80.80774, 1198],
  [16.638506, 80.970529, 1214],
  [16.322985, 80.961208, 1214],
  [16.4337801, 80.7678633, 1222],
  [16.367497, 80.843539, 1235],
  [16.638506, 80.970529, 1240],
  [16.5134135, 80.6652908, 1242],
  [16.367497, 80.843539, 1246],
  [16.70674, 81.00677, 1250],
  [16.5283487, 80.7941356, 1250],
  [16.5061743, 80.6480153, 1307],
  [16.523425, 80.775476, 1312],
  [16.5714134, 80.6818557, 1332],
  [16.367497, 80.843539, 1333],
  [16.367497, 80.843539, 1333],
  [16.367497, 80.843539, 1333],
  [16.367497, 80.843539, 1333],
  [16.367497, 80.843539, 1333],
  [16.367497, 80.843539, 1333],
  [16.367497, 80.843539, 1333],
  [16.367497, 80.843539, 1333],
  [16.367497, 80.843539, 1333],
  [16.5061743, 80.6480153, 1333],
  [16.322985, 80.961208, 1333],
  [16.4337801, 80.7678633, 1333],
  [16.4337801, 80.7678633, 1333],
  [16.5206918, 80.6406692, 1333],
  [16.367497, 80.843539, 1333],
  [16.367497, 80.843539, 1336],
  [16.5283487, 80.7941356, 1346],
  [16.4337801, 80.7678633, 1351],
  [16.4337801, 80.7678633, 1366],
  [16.377253, 80.837067, 1378],
  [17.0084792, 80.3759106, 1378],
  [16.4575524, 80.7400488, 1389],
  [16.5061743, 80.6480153, 1389],
  [16.604589, 80.619575, 1389],
  [16.442948, 80.751545, 1389],
  [16.479619, 80.5986106, 1389],
  [16.44275729, 80.77378856, 1391],
  [16.588781, 80.521874, 1407],
  [16.38839, 80.807107, 1420],
  [16.38839, 80.807107, 1420],
  [16.38839, 80.807107, 1420],
  [16.38839, 80.807107, 1420],
  [16.38839, 80.807107, 1420],
  [16.38839, 80.807107, 1420],
  [16.38839, 80.807107, 1420],
  [16.38839, 80.807107, 1420],
  [16.38839, 80.807107, 1420],
  [16.38839, 80.807107, 1420],
  [16.46062452, 80.68657647, 1422],
  [16.479619, 80.5986106, 1441],
  [16.4337801, 80.7678633, 1444],
  [16.4337801, 80.7678633, 1444],
  [16.4337801, 80.7678633, 1444],
  [16.4337801, 80.7678633, 1444],
  [16.38839, 80.807107, 1444],
  [16.38839, 80.807107, 1444],
  [16.322985, 80.961208, 1444],
  [16.5283487, 80.7941356, 1445],
  [16.453341, 80.607955, 1445],
  [16.5836552, 80.6153262, 1450],
  [16.523425, 80.775476, 1456],
  [16.5061743, 80.6480153, 1481],
  [16.322985, 80.961208, 1484],
  [16.5178632, 80.6507268, 1487],
  [16.658464, 80.409004, 1500],
  [16.4337801, 80.7678633, 1500],
  [16.5513305, 80.654154, 1512],
  [16.523425, 80.775476, 1521],
  [16.322985, 80.961208, 1545],
  [16.322985, 80.961208, 1545],
  [16.322985, 80.961208, 1545],
  [16.322985, 80.961208, 1545],
  [16.322985, 80.961208, 1545],
  [16.322985, 80.961208, 1545],
  [16.322985, 80.961208, 1545],
  [16.322985, 80.961208, 1545],
  [16.322985, 80.961208, 1545],
  [16.322985, 80.961208, 1545],
  [16.5354673, 80.6278964, 1553],
  [16.523425, 80.775476, 1556],
  [16.430795, 80.7650155, 1556],
  [16.5283487, 80.7941356, 1556],
  [16.658464, 80.409004, 1556],
  [16.658464, 80.409004, 1556],
  [16.437719, 80.740414, 1587],
  [16.5061743, 80.6480153, 1597],
  [16.5356484, 80.5924449, 1610],
  [17.0084792, 80.3759106, 1620],
  [16.523425, 80.775476, 1653],
  [16.377253, 80.837067, 1663],
  [16.5283487, 80.7941356, 1667],
  [16.4337801, 80.7678633, 1667],
  [16.523425, 80.775476, 1667],
  [16.5554752, 80.72971745, 1667],
  [16.44275729, 80.77378856, 1667],
  [16.5836552, 80.6153262, 1667],
  [16.658464, 80.409004, 1667],
  [16.5283487, 80.7941356, 1667],
  [16.5061743, 80.6480153, 1667],
  [16.658464, 80.409004, 1667],
  [16.589248, 80.521246, 1667],
  [16.377253, 80.837067, 1667],
  [16.5283487, 80.7941356, 1667],
  [16.5283487, 80.7941356, 1675],
  [16.5889686, 80.521422, 1684],
  [16.523425, 80.775476, 1701],
  [16.5061743, 80.6480153, 1708],
  [16.658464, 80.409004, 1722],
  [16.4337801, 80.7678633, 1750],
  [16.4337801, 80.7678633, 1750],
  [16.4337801, 80.7678633, 1750],
  [16.4337801, 80.7678633, 1750],
  [16.4337801, 80.7678633, 1750],
  [16.4337801, 80.7678633, 1750],
  [16.4337801, 80.7678633, 1750],
  [16.4337801, 80.7678633, 1750],
  [16.4337801, 80.7678633, 1750],
  [16.4337801, 80.7678633, 1750],
  [16.5061743, 80.6480153, 1750],
  [16.4337801, 80.7678633, 1750],
  [16.5513305, 80.654154, 1765],
  [16.4216986, 80.7538462, 1767],
  [16.4575524, 80.7400488, 1775],
  [16.54118, 80.5783809, 1777],
  [16.377253, 80.837067, 1778],
  [16.44275729, 80.77378856, 1778],
  [16.4337801, 80.7678633, 1778],
  [16.54118, 80.5783809, 1778],
  [16.5354673, 80.6278964, 1778],
  [16.5889686, 80.521422, 1778],
  [16.5889686, 80.521422, 1781],
  [16.4997252, 80.6560636, 1786],
  [16.538803, 80.64017066, 1804],
  [16.4903251002766, 80.6711626845324, 1826],
  [16.44275729, 80.77378856, 1833],
  [16.44275729, 80.77378856, 1833],
  [16.44275729, 80.77378856, 1833],
  [16.44275729, 80.77378856, 1833],
  [16.44275729, 80.77378856, 1833],
  [16.44275729, 80.77378856, 1833],
  [16.54118, 80.5783809, 1833],
  [16.44275729, 80.77378856, 1833],
  [16.44275729, 80.77378856, 1833],
  [16.44275729, 80.77378856, 1833],
  [16.44275729, 80.77378856, 1833],
  [16.44275729, 80.77378856, 1833],
  [16.44275729, 80.77378856, 1833],
  [16.4337801, 80.7678633, 1845],
  [16.613071, 80.918199, 1852],
  [16.5714134, 80.6818557, 1852],
  [16.5283487, 80.7941356, 1875],
  [16.658464, 80.409004, 1882],
  [16.5061743, 80.6480153, 1882],
  [16.5105301, 80.7477708, 1889],
  [16.638506, 80.970529, 1908],
  [17.0084792, 80.3759106, 1913],
  [16.437719, 80.740414, 1914],
  [16.437719, 80.740414, 1914],
  [16.437719, 80.740414, 1914],
  [16.437719, 80.740414, 1914],
  [16.437719, 80.740414, 1914],
  [16.437719, 80.740414, 1914],
  [16.437719, 80.740414, 1914],
  [16.437719, 80.740414, 1914],
  [16.437719, 80.740414, 1914],
  [16.437719, 80.740414, 1914],
  [16.60387, 80.4979, 1932],
  [16.4337801, 80.7678633, 1943],
  [16.658464, 80.409004, 1943],
  [16.5105301, 80.7477708, 1944],
  [16.4337801, 80.7678633, 1949],
  [16.7730685, 80.267503, 1970],
  [16.4267618, 80.5774534, 1990],
  [16.46816, 80.719534, 1994],
  [16.5554752, 80.72971745, 1996],
  [16.5714134, 80.6818557, 2000],
  [16.5061743, 80.6480153, 2000],
  [16.4337801, 80.7678633, 2000],
  [16.4337801, 80.7678633, 2000],
  [16.377253, 80.837067, 2000],
  [16.658464, 80.409004, 2000],
  [16.4337801, 80.7678633, 2000],
  [16.4903251002766, 80.6711626845324, 2000],
  [16.4337801, 80.7678633, 2000],
  [16.5354673, 80.6278964, 2000],
  [16.44275729, 80.77378856, 2000],
  [16.658464, 80.409004, 2000],
  [16.54118, 80.5783809, 2000],
  [16.4337801, 80.7678633, 2000],
  [16.5415147, 80.6417097, 2000],
  [16.638506, 80.970529, 2004],
  [16.367497, 80.843539, 2020],
  [16.5105301, 80.7477708, 2056],
  [16.4337801, 80.7678633, 2058],
  [16.4575524, 80.7400488, 2065],
  [16.6837219, 80.3955449, 2067],
  [16.5142496, 80.6514204, 2083],
  [16.5714134, 80.6818557, 2095],
  [16.4337801, 80.7678633, 2100],
  [16.4337801, 80.7678633, 2100],
  [16.4337801, 80.7678633, 2100],
  [16.4337801, 80.7678633, 2100],
  [16.4337801, 80.7678633, 2100],
  [16.4337801, 80.7678633, 2100],
  [16.4337801, 80.7678633, 2100],
  [16.4337801, 80.7678633, 2100],
  [16.4337801, 80.7678633, 2100],
  [16.4337801, 80.7678633, 2100],
  [16.4337801, 80.7678633, 2100],
  [16.4337801, 80.7678633, 2100],
  [16.5240791, 80.6770277, 2105],
  [16.46816, 80.719534, 2137],
  [16.5836552, 80.6153262, 2154],
  [16.523425, 80.775476, 2160],
  [16.4828392, 80.775969, 2174],
  [16.4216986, 80.7538462, 2189],
  [16.437719, 80.740414, 2197],
  [16.5415147, 80.6417097, 2222],
  [16.5415147, 80.6417097, 2222],
  [16.5415147, 80.6417097, 2222],
  [16.5415147, 80.6417097, 2222],
  [16.5415147, 80.6417097, 2222],
  [16.5415147, 80.6417097, 2222],
  [16.5415147, 80.6417097, 2222],
  [16.5415147, 80.6417097, 2222],
  [16.5415147, 80.6417097, 2222],
  [16.5415147, 80.6417097, 2222],
  [17.0084792, 80.3759106, 2222],
  [16.5714134, 80.6818557, 2222],
  [16.5286537, 80.6313041, 2222],
  [16.4337801, 80.7678633, 2222],
  [17.0084792, 80.3759106, 2222],
  [16.5283487, 80.7941356, 2222],
  [16.6837219, 80.3955449, 2222],
  [16.4337801, 80.7678633, 2222],
  [16.5061743, 80.6480153, 2222],
  [16.4337801, 80.7678633, 2222],
  [16.46816, 80.719534, 2222],
  [16.5061743, 80.6480153, 2242],
  [16.4267618, 80.5774534, 2244],
  [16.6837219, 80.3955449, 2257],
  [16.5714134, 80.6818557, 2273],
  [16.5714134, 80.6818557, 2273],
  [16.5714134, 80.6818557, 2273],
  [16.5714134, 80.6818557, 2273],
  [16.5714134, 80.6818557, 2273],
  [16.5714134, 80.6818557, 2273],
  [16.5714134, 80.6818557, 2273],
  [16.5714134, 80.6818557, 2273],
  [16.5714134, 80.6818557, 2273],
  [16.5714134, 80.6818557, 2273],
  [16.5061743, 80.6480153, 2296],
  [16.4575524, 80.7400488, 2307],
  [16.5061743, 80.6480153, 2315],
  [16.512848, 80.701085, 2333],
  [16.512848, 80.701085, 2333],
  [16.512848, 80.701085, 2333],
  [16.512848, 80.701085, 2333],
  [16.512848, 80.701085, 2333],
  [16.512848, 80.701085, 2333],
  [16.512848, 80.701085, 2333],
  [16.512848, 80.701085, 2333],
  [16.512848, 80.701085, 2333],
  [16.4575524, 80.7400488, 2333],
  [16.5470235, 80.6507268, 2333],
  [16.512848, 80.701085, 2333],
  [16.512848, 80.701085, 2333],
  [16.5061743, 80.6480153, 2350],
  [16.54118, 80.5783809, 2357],
  [16.4337801, 80.7678633, 2368],
  [16.5415147, 80.6417097, 2370],
  [16.522673, 80.666637, 2377],
  [16.538803, 80.64017066, 2400],
  [16.4216986, 80.7538462, 2439],
  [16.4216986, 80.7538462, 2439],
  [16.4216986, 80.7538462, 2439],
  [16.4216986, 80.7538462, 2439],
  [16.4216986, 80.7538462, 2439],
  [16.4216986, 80.7538462, 2439],
  [16.4216986, 80.7538462, 2439],
  [16.4216986, 80.7538462, 2439],
  [16.4216986, 80.7538462, 2439],
  [16.4216986, 80.7538462, 2439],
  [16.589248, 80.521246, 2444],
  [16.589248, 80.521246, 2444],
  [16.54118, 80.5783809, 2458],
  [16.478934, 80.690521, 2469],
  [16.4944613, 80.6652908, 2500],
  [16.5714134, 80.6818557, 2500],
  [16.613071, 80.918199, 2503],
  [16.46816, 80.719534, 2525],
  [16.46816, 80.719534, 2545],
  [16.4337801, 80.7678633, 2557],
  [16.568618, 80.545502, 2560],
  [16.4575524, 80.7400488, 2593],
  [16.5283487, 80.7941356, 2600],
  [16.589248, 80.521246, 2606],
  [16.638506, 80.970529, 2609],
  [17.0084792, 80.3759106, 2630],
  [16.46816, 80.719534, 2662],
  [16.601845, 80.892065, 2667],
  [16.4821909, 80.7006496, 2667],
  [16.5714134, 80.6818557, 2683],
  [16.4337801, 80.7678633, 2689],
  [16.44275729, 80.77378856, 2694],
  [16.5714134, 80.6818557, 2711],
  [16.5470235, 80.6507268, 2726],
  [16.322985, 80.961208, 2727],
  [16.5105301, 80.7477708, 2739],
  [16.474876, 80.605606, 2741],
  [16.5415147, 80.6417097, 2742],
  [16.4337801, 80.7678633, 2750],
  [16.5195944, 80.6875634, 2750],
  [16.442948, 80.751545, 2752],
  [16.5061743, 80.6480153, 2755],
  [16.5283487, 80.7941356, 2772],
  [16.5193543, 80.6840121, 2778],
  [16.5889686, 80.521422, 2778],
  [16.5193543, 80.6840121, 2778],
  [16.437719, 80.740414, 2778],
  [16.4337801, 80.7678633, 2778],
  [16.5283487, 80.7941356, 2778],
  [16.4309142, 80.5629399, 2784],
  [16.4337801, 80.7678633, 2785],
  [16.46816, 80.719534, 2791],
  [16.46816, 80.719534, 2791],
  [16.46816, 80.719534, 2791],
  [16.46816, 80.719534, 2791],
  [16.46816, 80.719534, 2791],
  [16.46816, 80.719534, 2791],
  [16.46816, 80.719534, 2791],
  [16.46816, 80.719534, 2791],
  [16.46816, 80.719534, 2791],
  [16.46816, 80.719534, 2791],
  [16.46816, 80.719534, 2791],
  [16.517205, 80.681306, 2800],
  [16.479619, 80.5986106, 2801],
  [16.4575524, 80.7400488, 2818],
  [16.56340779, 80.62326548, 2828],
  [16.5283487, 80.7941356, 2831],
  [16.5489578, 80.5966093, 2841],
  [16.5311839, 80.638935, 2850],
  [16.5415147, 80.6417097, 2857],
  [16.478934, 80.690521, 2860],
  [16.4267618, 80.5774534, 2861],
  [16.4267618, 80.5774534, 2861],
  [16.4267618, 80.5774534, 2861],
  [16.4267618, 80.5774534, 2861],
  [16.4267618, 80.5774534, 2861],
  [16.4267618, 80.5774534, 2861],
  [16.4267618, 80.5774534, 2861],
  [16.4267618, 80.5774534, 2861],
  [16.4267618, 80.5774534, 2861],
  [16.4267618, 80.5774534, 2861],
  [16.4267618, 80.5774534, 2861],
  [16.5889686, 80.521422, 2883],
  [16.4575524, 80.7400488, 2889],
  [16.5061743, 80.6480153, 2889],
  [16.5283487, 80.7941356, 2900],
  [16.478934, 80.690521, 2916],
  [16.4575524, 80.7400488, 2959],
  [16.5061743, 80.6480153, 2975],
  [16.638506, 80.970529, 2976],
  [16.5121419, 80.6694514, 2998],
  [16.5025858, 80.7111025, 2999],
  [16.5121419, 80.6694514, 3000],
  [16.5134135, 80.6652908, 3000],
  [16.5134135, 80.6652908, 3000],
  [16.5134135, 80.6652908, 3000],
  [16.4962579, 80.6403223, 3000],
  [16.5085425, 80.6541946, 3000],
  [16.5085425, 80.6541946, 3000],
  [16.5356484, 80.5924449, 3000],
  [16.5356484, 80.5924449, 3000],
  [16.5121419, 80.6694514, 3000],
  [16.4977172305877, 80.6545350343677, 3000],
  [16.5061743, 80.6480153, 3000],
  [16.5061743, 80.6480153, 3000],
  [16.5061743, 80.6480153, 3000],
  [16.5121419, 80.6694514, 3000],
  [16.5069461, 80.6673711, 3000],
  [16.5069461, 80.6673711, 3000],
  [16.5283487, 80.7941356, 3000],
  [16.5356484, 80.5924449, 3000],
  [16.5025858, 80.7111025, 3000],
  [16.5085425, 80.6541946, 3000],
  [16.46062452, 80.68657647, 3000],
  [16.5366511, 80.6146524, 3000],
  [16.5085425, 80.6541946, 3000],
  [16.5102634, 80.7153173, 3000],
  [16.5356484, 80.5924449, 3000],
  [16.4977172305877, 80.6545350343677, 3000],
  [16.54118, 80.5783809, 3000],
  [16.4905671, 80.6923312, 3000],
  [16.4267618, 80.5774534, 3000],
  [16.5283487, 80.7941356, 3000],
  [16.5102634, 80.7153173, 3000],
  [16.5025858, 80.7111025, 3000],
  [16.4977172305877, 80.6545350343677, 3003],
  [16.5283487, 80.7941356, 3024],
  [16.4821909, 80.7006496, 3030],
  [16.3857534, 80.584057, 3030],
  [16.589248, 80.521246, 3040],
  [16.4337801, 80.7678633, 3043],
  [16.437719, 80.740414, 3053],
  [16.526609, 80.6367077, 3058],
  [16.5240791, 80.6770277, 3060],
  [16.377253, 80.837067, 3064],
  [16.483373, 80.6618234, 3079],
  [16.5283487, 80.7941356, 3088],
  [16.5714134, 80.6818557, 3111],
  [16.4821909, 80.7006496, 3111],
  [17.0084792, 80.3759106, 3111],
  [16.5105301, 80.7477708, 3112],
  [16.4337801, 80.7678633, 3125],
  [16.5195944, 80.6875634, 3125],
  [16.5889686, 80.521422, 3139],
  [16.5074896, 80.6812287, 3143],
  [16.5283487, 80.7941356, 3158],
  [16.4267618, 80.5774534, 3160],
  [16.512848, 80.701085, 3167],
  [16.568618, 80.545502, 3167],
  [16.5283487, 80.7941356, 3173],
  [16.5283487, 80.7941356, 3175],
  [16.5283487, 80.7941356, 3187],
  [16.5283487, 80.7941356, 3200],
  [16.5283487, 80.7941356, 3205],
  [16.5415147, 80.6417097, 3210],
  [16.5283487, 80.7941356, 3214],
  [16.4821909, 80.7006496, 3220],
  [16.5061743, 80.6480153, 3222],
  [16.5714134, 80.6818557, 3222],
  [16.5513305, 80.654154, 3232],
  [16.4216986, 80.7538462, 3244],
  [16.4216986, 80.7538462, 3244],
  [16.512848, 80.701085, 3245],
  [16.5102634, 80.7153173, 3246],
  [16.5193543, 80.6840121, 3249],
  [16.4862642, 80.6857453, 3250],
  [16.5236645, 80.6014674, 3259],
  [16.7730685, 80.267503, 3266],
  [16.5102634, 80.7153173, 3271],
  [17.0084792, 80.3759106, 3278],
  [16.5283487, 80.7941356, 3280],
  [16.4821909, 80.7006496, 3283],
  [16.538803, 80.64017066, 3292],
  [16.5126292, 80.68191524, 3294],
  [16.54118, 80.5783809, 3294],
  [16.512848, 80.701085, 3300],
  [16.54176125, 80.62956382, 3300],
  [16.54118, 80.5783809, 3306],
  [16.5513305, 80.654154, 3320],
  [16.583068, 80.8920773, 3331],
  [16.5061743, 80.6480153, 3333],
  [16.5061743, 80.6480153, 3333],
  [16.5061743, 80.6480153, 3333],
  [16.5061743, 80.6480153, 3333],
  [16.5061743, 80.6480153, 3333],
  [16.5061743, 80.6480153, 3333],
  [16.5061743, 80.6480153, 3333],
  [16.5061743, 80.6480153, 3333],
  [16.5061743, 80.6480153, 3333],
  [16.4821909, 80.7006496, 3333],
  [16.5061743, 80.6480153, 3333],
  [16.5195944, 80.6875634, 3333],
  [16.52633, 80.6042897, 3333],
  [16.54118, 80.5783809, 3333],
  [16.5889686, 80.521422, 3333],
  [16.491465, 80.681385, 3333],
  [16.5714134, 80.6818557, 3333],
  [16.5061743, 80.6480153, 3333],
  [16.4267618, 80.5774534, 3342],
  [16.4822628, 80.6623603, 3360],
  [16.522673, 80.666637, 3364],
  [16.5266108, 80.6507268, 3368],
  [16.5283487, 80.7941356, 3375],
  [16.54118, 80.5783809, 3385],
  [16.5195944, 80.6875634, 3391],
  [16.523425, 80.775476, 3391],
  [16.5061743, 80.6480153, 3391],
  [16.5061743, 80.6480153, 3400],
  [16.5283487, 80.7941356, 3400],
  [16.5415147, 80.6417097, 3401],
  [16.583068, 80.8920773, 3426],
  [16.70674, 81.00677, 3429],
  [16.522673, 80.666637, 3438],
  [16.4821909, 80.7006496, 3439],
  [16.5283487, 80.7941356, 3443],
  [16.538803, 80.64017066, 3444],
  [16.4903251002766, 80.6711626845324, 3448],
  [16.4997252, 80.6560636, 3462],
  [16.5714134, 80.6818557, 3471],
  [16.5074896, 80.6812287, 3478],
  [16.5195944, 80.6875634, 3478],
  [16.5061743, 80.6480153, 3488],
  [16.5102634, 80.7153173, 3495],
  [16.538803, 80.64017066, 3497],
  [16.478934, 80.690521, 3500],
  [16.54118, 80.5783809, 3500],
  [16.5283487, 80.7941356, 3500],
  [16.5074896, 80.6812287, 3500],
  [16.4337801, 80.7678633, 3500],
  [16.568618, 80.545502, 3500],
  [16.5283487, 80.7941356, 3500],
  [16.5195944, 80.6875634, 3500],
  [16.5415147, 80.6417097, 3500],
  [16.4821909, 80.7006496, 3505],
  [16.4337801, 80.7678633, 3506],
  [16.5061743, 80.6480153, 3512],
  [16.5193543, 80.6840121, 3518],
  [16.5195944, 80.6875634, 3519],
  [16.5354673, 80.6278964, 3526],
  [16.4822628, 80.6623603, 3529],
  [16.5193543, 80.6840121, 3531],
  [16.512848, 80.701085, 3535],
  [16.46816, 80.719534, 3543],
  [16.52893212, 80.63047307, 3555],
  [16.5415147, 80.6417097, 3556],
  [16.5470235, 80.6507268, 3556],
  [16.5714134, 80.6818557, 3556],
  [16.46816, 80.719534, 3556],
  [16.568618, 80.545502, 3560],
  [16.5836552, 80.6153262, 3580],
  [16.540273, 80.635955, 3583],
  [16.4905671, 80.6923312, 3585],
  [16.54118, 80.5783809, 3590],
  [16.4903251002766, 80.6711626845324, 3600],
  [16.5195944, 80.6875634, 3600],
  [16.5061743, 80.6480153, 3600],
  [16.5311839, 80.638935, 3600],
  [16.7730685, 80.267503, 3604],
  [16.5195944, 80.6875634, 3615],
  [16.7730685, 80.267503, 3619],
  [16.5195944, 80.6875634, 3620],
  [16.474876, 80.605606, 3629],
  [16.4821909, 80.7006496, 3636],
  [16.540273, 80.635955, 3636],
  [16.5074896, 80.6812287, 3636],
  [16.5195944, 80.6875634, 3636],
  [16.5074896, 80.6812287, 3652],
  [16.521976, 80.6319316, 3657],
  [16.568618, 80.545502, 3664],
  [16.54118, 80.5783809, 3666],
  [16.4267618, 80.5774534, 3667],
  [16.535096, 80.62141, 3667],
  [16.5193543, 80.6840121, 3667],
  [16.70674, 81.00677, 3667],
  [16.4821909, 80.7006496, 3667],
  [16.46816, 80.719534, 3667],
  [16.437719, 80.740414, 3672],
  [16.4821909, 80.7006496, 3676],
  [16.5970856, 80.5167555, 3680],
  [16.538803, 80.64017066, 3680],
  [16.523425, 80.775476, 3686],
  [16.5193543, 80.6840121, 3688],
  [16.4267618, 80.5774534, 3692],
  [16.4267618, 80.5774534, 3692],
  [16.4267618, 80.5774534, 3692],
  [16.4267618, 80.5774534, 3692],
  [16.4267618, 80.5774534, 3692],
  [16.4267618, 80.5774534, 3692],
  [16.4267618, 80.5774534, 3692],
  [16.4267618, 80.5774534, 3692],
  [16.4267618, 80.5774534, 3692],
  [16.4267618, 80.5774534, 3692],
  [16.4267618, 80.5774534, 3692],
  [16.5513305, 80.654154, 3695],
  [16.5074896, 80.6812287, 3700],
  [16.483586, 80.672972, 3704],
  [16.56340779, 80.62326548, 3704],
  [16.5193543, 80.6840121, 3704],
  [16.538803, 80.64017066, 3710],
  [16.4905671, 80.6923312, 3714],
  [16.568618, 80.545502, 3723],
  [16.5415147, 80.6417097, 3723],
  [16.4821909, 80.7006496, 3730],
  [16.512848, 80.701085, 3739],
  [16.488238, 80.654882, 3750],
  [16.322985, 80.961208, 3750],
  [16.538803, 80.64017066, 3750],
  [16.5415147, 80.6417097, 3750],
  [16.4822628, 80.6623603, 3750],
  [16.479619, 80.5986106, 3759],
  [16.5061743, 80.6480153, 3772],
  [16.478934, 80.690521, 3778],
  [16.5714134, 80.6818557, 3778],
  [16.538803, 80.64017066, 3778],
  [16.4905671, 80.6923312, 3778],
  [16.5513305, 80.654154, 3784],
  [16.4905671, 80.6923312, 3787],
  [16.4822628, 80.6623603, 3793],
  [16.5193543, 80.6840121, 3810],
  [16.5283487, 80.7941356, 3810],
  [16.54118, 80.5783809, 3819],
  [16.4944613, 80.6652908, 3819],
  [16.4905671, 80.6923312, 3833],
  [16.5195944, 80.6875634, 3838],
  [16.367497, 80.843539, 3846],
  [16.604589, 80.619575, 3846],
  [16.453341, 80.607955, 3850],
  [16.54118, 80.5783809, 3852],
  [16.522673, 80.666637, 3853],
  [16.5415147, 80.6417097, 3864],
  [16.4821909, 80.7006496, 3864],
  [16.514075, 80.6313041, 3867],
  [16.522673, 80.666637, 3889],
  [16.5415147, 80.6417097, 3889],
  [16.5513305, 80.654154, 3889],
  [16.5513305, 80.654154, 3889],
  [16.522673, 80.666637, 3889],
  [16.5354673, 80.6278964, 3893],
  [16.5062379, 80.6434438, 3898],
  [16.5889686, 80.521422, 3903],
  [16.4337801, 80.7678633, 3906],
  [16.483373, 80.6618234, 3906],
  [16.5283487, 80.7941356, 3909],
  [16.54118, 80.5783809, 3909],
  [16.5061743, 80.6480153, 3910],
  [16.5195944, 80.6875634, 3913],
  [16.51577734, 80.60770092, 3917],
  [16.479619, 80.5986106, 3920],
  [16.4905671, 80.6923312, 3920],
  [16.5240791, 80.6770277, 3943],
  [16.5025858, 80.7111025, 3947],
  [16.4821909, 80.7006496, 3947],
  [16.517205, 80.681306, 3955],
  [16.5311839, 80.638935, 3975],
  [16.4575524, 80.7400488, 3992],
  [16.4575524, 80.7400488, 3992],
  [16.4575524, 80.7400488, 3992],
  [16.4575524, 80.7400488, 3992],
  [16.4575524, 80.7400488, 3992],
  [16.4575524, 80.7400488, 3992],
  [16.4575524, 80.7400488, 3992],
  [16.4575524, 80.7400488, 3992],
  [16.4575524, 80.7400488, 3992],
  [16.4575524, 80.7400488, 3992],
  [16.5074896, 80.6812287, 4000],
  [16.5102634, 80.7153173, 4000],
  [16.4905671, 80.6923312, 4000],
  [16.5283487, 80.7941356, 4000],
  [16.54118, 80.5783809, 4000],
  [16.568618, 80.545502, 4000],
  [16.54118, 80.5783809, 4000],
  [16.5283487, 80.7941356, 4000],
  [16.4267618, 80.5774534, 4000],
  [16.5415147, 80.6417097, 4000],
  [16.5061743, 80.6480153, 4000],
  [16.5195944, 80.6875634, 4000],
  [16.5311839, 80.638935, 4000],
  [16.5283487, 80.7941356, 4000],
  [16.46816, 80.719534, 4000],
  [16.5206918, 80.6406692, 4000],
  [16.527059, 80.598294, 4027],
  [16.4821909, 80.7006496, 4030],
  [16.527059, 80.598294, 4042],
  [16.5061743, 80.6480153, 4045],
  [16.442948, 80.751545, 4059],
  [16.46816, 80.719534, 4062],
  [16.521976, 80.6319316, 4063],
  [16.538803, 80.64017066, 4065],
  [16.523425, 80.775476, 4067],
  [16.523425, 80.775476, 4067],
  [16.523425, 80.775476, 4067],
  [16.523425, 80.775476, 4067],
  [16.523425, 80.775476, 4067],
  [16.523425, 80.775476, 4067],
  [16.523425, 80.775476, 4067],
  [16.523425, 80.775476, 4067],
  [16.523425, 80.775476, 4067],
  [16.523425, 80.775476, 4067],
  [16.523425, 80.775476, 4067],
  [16.4821909, 80.7006496, 4068],
  [16.4267618, 80.5774534, 4069],
  [16.4905671, 80.6923312, 4074],
  [16.4905671, 80.6923312, 4074],
  [16.4905671, 80.6923312, 4074],
  [16.4905671, 80.6923312, 4074],
  [16.4905671, 80.6923312, 4074],
  [16.4905671, 80.6923312, 4074],
  [16.4905671, 80.6923312, 4074],
  [16.4905671, 80.6923312, 4074],
  [16.4905671, 80.6923312, 4074],
  [16.4905671, 80.6923312, 4074],
  [16.4267618, 80.5774534, 4076],
  [16.4267618, 80.5774534, 4077],
  [16.5513305, 80.654154, 4078],
  [16.4905671, 80.6923312, 4083],
  [16.54118, 80.5783809, 4090],
  [16.512848, 80.701085, 4091],
  [16.4997252, 80.6560636, 4091],
  [16.4821909, 80.7006496, 4094],
  [16.54118, 80.5783809, 4099],
  [16.517205, 80.681306, 4103],
  [16.5061743, 80.6480153, 4109],
  [16.4821909, 80.7006496, 4111],
  [16.5102634, 80.7153173, 4115],
  [16.5102634, 80.7153173, 4118],
  [16.4905671, 80.6923312, 4118],
  [16.527059, 80.598294, 4121],
  [16.46816, 80.719534, 4133],
  [16.5102634, 80.7153173, 4135],
  [16.5193543, 80.6840121, 4160],
  [16.5102634, 80.7153173, 4160],
  [16.478934, 80.690521, 4161],
  [16.527059, 80.598294, 4166],
  [16.7730685, 80.267503, 4167],
  [16.5283487, 80.7941356, 4167],
  [16.5889686, 80.521422, 4167],
  [16.517205, 80.681306, 4167],
  [16.523425, 80.775476, 4174],
  [16.54118, 80.5783809, 4175],
  [16.54118, 80.5783809, 4179],
  [16.4821909, 80.7006496, 4183],
  [16.5889686, 80.521422, 4189],
  [16.4821909, 80.7006496, 4195],
  [16.527059, 80.598294, 4195],
  [16.5714134, 80.6818557, 4200],
  [16.4821909, 80.7006496, 4200],
  [16.5714134, 80.6818557, 4200],
  [16.4821909, 80.7006496, 4200],
  [16.522673, 80.666637, 4222],
  [16.4905671, 80.6923312, 4231],
  [16.4821909, 80.7006496, 4250],
  [16.4997252, 80.6560636, 4250],
  [16.4337801, 80.7678633, 4260],
  [16.4337801, 80.7678633, 4260],
  [16.4905671, 80.6923312, 4261],
  [16.4821909, 80.7006496, 4262],
  [16.5513305, 80.654154, 4263],
  [16.4905671, 80.6923312, 4267],
  [16.4575524, 80.7400488, 4278],
  [16.5283487, 80.7941356, 4285],
  [16.540273, 80.635955, 4286],
  [16.5193543, 80.6840121, 4286],
  [16.522673, 80.666637, 4286],
  [16.5102634, 80.7153173, 4300],
  [16.5970856, 80.5167555, 4302],
  [16.5889686, 80.521422, 4304],
  [16.4905671, 80.6923312, 4310],
  [16.4905671, 80.6923312, 4318],
  [16.4821909, 80.7006496, 4331],
  [16.4267618, 80.5774534, 4333],
  [16.4919953, 80.6590494, 4333],
  [16.479619, 80.5986106, 4333],
  [16.479619, 80.5986106, 4333],
  [16.479619, 80.5986106, 4333],
  [16.479619, 80.5986106, 4333],
  [16.479619, 80.5986106, 4333],
  [16.479619, 80.5986106, 4333],
  [16.479619, 80.5986106, 4333],
  [16.479619, 80.5986106, 4333],
  [16.479619, 80.5986106, 4333],
  [16.479619, 80.5986106, 4333],
  [16.5088669, 80.6451779, 4334],
  [16.538803, 80.64017066, 4342],
  [16.5240791, 80.6770277, 4363],
  [16.483586, 80.672972, 4364],
  [16.5714134, 80.6818557, 4367],
  [16.5178632, 80.6507268, 4370],
  [16.521976, 80.6319316, 4375],
  [16.5085425, 80.6541946, 4384],
  [16.568618, 80.545502, 4385],
  [16.568618, 80.545502, 4385],
  [16.568618, 80.545502, 4385],
  [16.568618, 80.545502, 4385],
  [16.568618, 80.545502, 4385],
  [16.568618, 80.545502, 4385],
  [16.568618, 80.545502, 4385],
  [16.568618, 80.545502, 4385],
  [16.568618, 80.545502, 4385],
  [16.568618, 80.545502, 4385],
  [16.5049539, 80.6229787, 4386],
  [16.5415147, 80.6417097, 4390],
  [16.5513305, 80.654154, 4400],
  [16.4575524, 80.7400488, 4403],
  [16.5195944, 80.6875634, 4423],
  [16.538803, 80.64017066, 4427],
  [16.4915329, 80.6000794, 4429],
  [16.54118, 80.5783809, 4430],
  [16.54118, 80.5783809, 4430],
  [16.54118, 80.5783809, 4430],
  [16.54118, 80.5783809, 4430],
  [16.54118, 80.5783809, 4430],
  [16.54118, 80.5783809, 4430],
  [16.54118, 80.5783809, 4430],
  [16.54118, 80.5783809, 4430],
  [16.54118, 80.5783809, 4430],
  [16.54176125, 80.62956382, 4430],
  [16.54118, 80.5783809, 4430],
  [16.4575524, 80.7400488, 4431],
  [16.5195944, 80.6875634, 4444],
  [16.568618, 80.545502, 4444],
  [16.4267618, 80.5774534, 4444],
  [16.512848, 80.701085, 4444],
  [16.5195944, 80.6875634, 4444],
  [16.538803, 80.64017066, 4444],
  [16.5195944, 80.6875634, 4444],
  [16.5193543, 80.6840121, 4474],
  [16.4575524, 80.7400488, 4487],
  [16.4821909, 80.7006496, 4498],
  [16.502393, 80.655235, 4500],
  [16.533109, 80.6007734, 4500],
  [16.5074896, 80.6812287, 4500],
  [16.5102634, 80.7153173, 4508],
  [16.5470235, 80.6507268, 4513],
  [16.4905671, 80.6923312, 4516],
  [16.52633, 80.6042897, 4521],
  [16.499589, 80.677748, 4522],
  [16.4821909, 80.7006496, 4523],
  [16.4905671, 80.6923312, 4528],
  [16.589248, 80.521246, 4531],
  [16.5266108, 80.6507268, 4537],
  [16.5099088, 80.6714597, 4543],
  [16.510478, 80.659133, 4545],
  [16.5074896, 80.6812287, 4545],
  [16.478934, 80.690521, 4545],
  [16.54118, 80.5783809, 4545],
  [16.4267618, 80.5774534, 4554],
  [16.5415147, 80.6417097, 4556],
  [16.5195944, 80.6875634, 4556],
  [16.5283487, 80.7941356, 4559],
  [16.5240791, 80.6770277, 4562],
  [16.4821909, 80.7006496, 4571],
  [16.54176125, 80.62956382, 4571],
  [16.56340779, 80.62326548, 4573],
  [16.479619, 80.5986106, 4580],
  [16.538803, 80.64017066, 4583],
  [16.538803, 80.64017066, 4583],
  [16.479619, 80.5986106, 4583],
  [16.5195944, 80.6875634, 4583],
  [16.5311839, 80.638935, 4591],
  [16.4821909, 80.7006496, 4594],
  [16.4267618, 80.5774534, 4594],
  [16.4905671, 80.6923312, 4595],
  [16.4709151, 80.5613762, 4598],
  [16.5074896, 80.6812287, 4600],
  [16.522673, 80.666637, 4602],
  [16.5061743, 80.6480153, 4607],
  [16.532511, 80.64256, 4614],
  [16.532511, 80.64256, 4615],
  [16.4915329, 80.6000794, 4617],
  [16.474876, 80.605606, 4650],
  [16.478934, 80.690521, 4651],
  [16.5415147, 80.6417097, 4658],
  [16.5121419, 80.6694514, 4667],
  [16.527059, 80.598294, 4667],
  [16.4905671, 80.6923312, 4669],
  [16.4822628, 80.6623603, 4688],
  [16.523425, 80.775476, 4702],
  [16.5122722261914, 80.6728976127145, 4706],
  [16.4997252, 80.6560636, 4706],
  [16.538803, 80.64017066, 4706],
  [16.5366511, 80.6146524, 4714],
  [16.522673, 80.666637, 4721],
  [16.532511, 80.64256, 4722],
  [16.4905671, 80.6923312, 4727],
  [16.527059, 80.598294, 4730],
  [16.517205, 80.681306, 4737],
  [16.491371, 80.675144, 4750],
  [16.5061743, 80.6480153, 4750],
  [16.532511, 80.64256, 4755],
  [16.54118, 80.5783809, 4762],
  [16.5069461, 80.6673711, 4783],
  [16.5061743, 80.6480153, 4798],
  [16.5193543, 80.6840121, 4800],
  [16.5074896, 80.6812287, 4800],
  [16.517205, 80.681306, 4800],
  [16.54118, 80.5783809, 4800],
  [16.5122722261914, 80.6728976127145, 4824],
  [16.54176125, 80.62956382, 4832],
  [16.517205, 80.681306, 4833],
  [16.545296, 80.639561, 4847],
  [16.545296, 80.639561, 4847],
  [16.545296, 80.639561, 4847],
  [16.545296, 80.639561, 4847],
  [16.545296, 80.639561, 4847],
  [16.545296, 80.639561, 4847],
  [16.545296, 80.639561, 4847],
  [16.545296, 80.639561, 4847],
  [16.545296, 80.639561, 4847],
  [16.545296, 80.639561, 4847],
  [16.4944613, 80.6652908, 4848],
  [16.521976, 80.6319316, 4853],
  [16.5193543, 80.6840121, 4861],
  [16.512848, 80.701085, 4861],
  [16.5074896, 80.6812287, 4870],
  [16.54118, 80.5783809, 4872],
  [16.5061743, 80.6480153, 4874],
  [16.54118, 80.5783809, 4884],
  [16.5099088, 80.6714597, 4891],
  [16.54118, 80.5783809, 4900],
  [16.523425, 80.775476, 4913],
  [16.4821909, 80.7006496, 4919],
  [16.4862642, 80.6857453, 4945],
  [16.5135205, 80.6068458, 4950],
  [16.4905671, 80.6923312, 4960],
  [16.5061743, 80.6480153, 4965],
  [16.4905671, 80.6923312, 5000],
  [16.5193543, 80.6840121, 5000],
  [16.527059, 80.598294, 5000],
  [17.0084792, 80.3759106, 5000],
  [16.4905671, 80.6923312, 5000],
  [16.4905671, 80.6923312, 5000],
  [16.521976, 80.6319316, 5000],
  [16.5088669, 80.6451779, 5000],
  [16.488238, 80.654882, 5000],
  [16.474876, 80.605606, 5000],
  [16.4821909, 80.7006496, 5000],
  [16.4905671, 80.6923312, 5000],
  [16.5311839, 80.638935, 5000],
  [16.512848, 80.701085, 5000],
  [16.4962579, 80.6403223, 5000],
  [16.4821909, 80.7006496, 5000],
  [16.5074896, 80.6812287, 5000],
  [16.5027866, 80.6396287, 5000],
  [16.478934, 80.690521, 5000],
  [16.4267618, 80.5774534, 5000],
  [16.5061743, 80.6480153, 5004],
  [16.54118, 80.5783809, 5009],
  [16.54118, 80.5783809, 5015],
  [16.533109, 80.6007734, 5026],
  [16.5122722261914, 80.6728976127145, 5040],
  [16.5074896, 80.6812287, 5057],
  [16.4821909, 80.7006496, 5058],
  [16.4962579, 80.6403223, 5072],
  [16.4267618, 80.5774534, 5072],
  [16.4905671, 80.6923312, 5076],
  [16.512848, 80.701085, 5079],
  [16.5061743, 80.6480153, 5090],
  [16.5088669, 80.6451779, 5096],
  [16.5513305, 80.654154, 5098],
  [16.5270867, 80.6422191, 5101],
  [16.5099088, 80.6714597, 5102],
  [16.4905671, 80.6923312, 5104],
  [16.4821909, 80.7006496, 5108],
  [16.568618, 80.545502, 5117],
  [16.54176125, 80.62956382, 5132],
  [16.4915329, 80.6000794, 5133],
  [16.5240791, 80.6770277, 5133],
  [16.5121419, 80.6694514, 5135],
  [16.521976, 80.6319316, 5147],
  [16.522673, 80.666637, 5164],
  [16.568618, 80.545502, 5183],
  [16.523425, 80.775476, 5185],
  [16.4821909, 80.7006496, 5188],
  [16.4821909, 80.7006496, 5200],
  [16.5061743, 80.6480153, 5200],
  [16.517205, 80.681306, 5200],
  [16.4337801, 80.7678633, 5204],
  [16.4821909, 80.7006496, 5208],
  [16.478934, 80.690521, 5222],
  [16.522673, 80.666637, 5226],
  [16.54118, 80.5783809, 5242],
  [16.4267618, 80.5774534, 5244],
  [16.474876, 80.605606, 5245],
  [16.474876, 80.605606, 5246],
  [16.5069461, 80.6673711, 5250],
  [16.5074896, 80.6812287, 5250],
  [16.5354673, 80.6278964, 5263],
  [16.527059, 80.598294, 5273],
  [16.5266108, 80.6507268, 5273],
  [16.4905671, 80.6923312, 5273],
  [16.4267618, 80.5774534, 5306],
  [16.54118, 80.5783809, 5311],
  [16.4821909, 80.7006496, 5312],
  [16.491371, 80.675144, 5314],
  [16.479619, 80.5986106, 5324],
  [16.5085425, 80.6541946, 5328],
  [16.488238, 80.654882, 5333],
  [16.46062452, 80.68657647, 5333],
  [16.4905671, 80.6923312, 5333],
  [16.533109, 80.6007734, 5342],
  [16.568618, 80.545502, 5348],
  [16.502393, 80.655235, 5357],
  [16.479619, 80.5986106, 5362],
  [16.5283487, 80.7941356, 5364],
  [16.7730685, 80.267503, 5371],
  [16.51209475, 80.63794738, 5376],
  [16.517205, 80.681306, 5378],
  [16.483586, 80.672972, 5379],
  [16.526609, 80.6367077, 5380],
  [16.5061743, 80.6480153, 5385],
  [16.479619, 80.5986106, 5400],
  [16.4919953, 80.6590494, 5417],
  [16.479619, 80.5986106, 5419],
  [16.479619, 80.5986106, 5434],
  [16.5415147, 80.6417097, 5434],
  [16.4944613, 80.6652908, 5455],
  [16.491371, 80.675144, 5463],
  [16.4944613, 80.6652908, 5476],
  [16.46816, 80.719534, 5483],
  [16.5061743, 80.6480153, 5500],
  [16.478934, 80.690521, 5500],
  [16.5121419, 80.6694514, 5500],
  [16.474876, 80.605606, 5508],
  [16.5061743, 80.6480153, 5510],
  [16.5061743, 80.6480153, 5524],
  [16.52633, 80.6042897, 5538],
  [16.4905671, 80.6923312, 5538],
  [16.5178632, 80.6507268, 5556],
  [16.54118, 80.5783809, 5556],
  [16.6837219, 80.3955449, 5556],
  [16.538803, 80.64017066, 5556],
  [16.5074896, 80.6812287, 5556],
  [16.508583, 80.6642443, 5556],
  [16.5266108, 80.6507268, 5574],
  [16.483586, 80.672972, 5600],
  [16.5240791, 80.6770277, 5612],
  [16.479619, 80.5986106, 5636],
  [16.4821909, 80.7006496, 5652],
  [16.5122722261914, 80.6728976127145, 5660],
  [16.514075, 80.6313041, 5667],
  [16.474876, 80.605606, 5678],
  [16.5061743, 80.6480153, 5692],
  [16.4575524, 80.7400488, 5714],
  [16.5193543, 80.6840121, 5714],
  [16.527059, 80.598294, 5750],
  [16.4903251002766, 80.6711626845324, 5768],
  [16.538803, 80.64017066, 5778],
  [16.5463536, 80.6483696, 5787],
  [16.5195944, 80.6875634, 5833],
  [16.4903251002766, 80.6711626845324, 5833],
  [16.5367353, 80.8039176, 5848],
  [16.474876, 80.605606, 5887],
  [16.5025858, 80.7111025, 5903],
  [16.479619, 80.5986106, 5909],
  [16.4862642, 80.6857453, 5929],
  [16.4905671, 80.6923312, 5952],
  [16.478934, 80.690521, 5980],
  [16.474876, 80.605606, 6000],
  [16.5061743, 80.6480153, 6000],
  [16.5270867, 80.6422191, 6000],
  [16.4575524, 80.7400488, 6000],
  [16.54118, 80.5783809, 6024],
  [17.0084792, 80.3759106, 6027],
  [16.5099088, 80.6714597, 6033],
  [16.479619, 80.5986106, 6036],
  [16.540273, 80.635955, 6047],
  [16.5470235, 80.6507268, 6047],
  [16.521976, 80.6319316, 6054],
  [16.377253, 80.837067, 6068],
  [16.5513305, 80.654154, 6111],
  [16.5265801, 80.6014674, 6121],
  [16.658464, 80.409004, 6122],
  [16.4944613, 80.6652908, 6122],
  [16.5195944, 80.6875634, 6200],
  [16.5102634, 80.7153173, 6202],
  [16.5283487, 80.7941356, 6207],
  [16.4944613, 80.6652908, 6242],
  [16.5025858, 80.7111025, 6250],
  [16.5061743, 80.6480153, 6250],
  [16.512848, 80.701085, 6264],
  [16.5122722261914, 80.6728976127145, 6272],
  [16.532511, 80.64256, 6296],
  [16.4905671, 80.6923312, 6304],
  [16.5240791, 80.6770277, 6309],
  [17.0084792, 80.3759106, 6333],
  [16.5102634, 80.7153173, 6356],
  [16.5178632, 80.6507268, 6358],
  [16.4821909, 80.7006496, 6369],
  [16.5074896, 80.6812287, 6383],
  [16.4944613, 80.6652908, 6417],
  [16.517205, 80.681306, 6428],
  [16.517205, 80.681306, 6428],
  [16.5099088, 80.6714597, 6443],
  [16.532511, 80.64256, 6470],
  [16.51209475, 80.63794738, 6474],
  [16.5061743, 80.6480153, 6481],
  [16.488238, 80.654882, 6487],
  [16.488238, 80.654882, 6500],
  [16.5061743, 80.6480153, 6500],
  [16.488238, 80.654882, 6500],
  [16.512854, 80.611258, 6530],
  [16.5415147, 80.6417097, 6536],
  [16.478934, 80.690521, 6545],
  [16.4267618, 80.5774534, 6576],
  [16.512848, 80.701085, 6589],
  [16.367497, 80.843539, 6602],
  [16.5049539, 80.6229787, 6652],
  [16.512848, 80.701085, 6659],
  [16.5099088, 80.6714597, 6660],
  [16.5105301, 80.7477708, 6666],
  [16.5088669, 80.6451779, 6666],
  [16.5354673, 80.6278964, 6667],
  [16.4962579, 80.6403223, 6667],
  [16.5049539, 80.6229787, 6667],
  [16.5061743, 80.6480153, 6667],
  [16.5415147, 80.6417097, 6667],
  [16.5027866, 80.6396287, 6667],
  [16.4862642, 80.6857453, 6667],
  [16.4821909, 80.7006496, 6689],
  [16.514075, 80.6313041, 6701],
  [16.479619, 80.5986106, 6706],
  [16.508583, 80.6642443, 6757],
  [16.4919953, 80.6590494, 6818],
  [16.4337801, 80.7678633, 6818],
  [16.483586, 80.672972, 6818],
  [16.535096, 80.62141, 6833],
  [16.4821909, 80.7006496, 6887],
  [16.5195944, 80.6875634, 6888],
  [16.4905671, 80.6923312, 6890],
  [16.4821909, 80.7006496, 6899],
  [16.5122722261914, 80.6728976127145, 6912],
  [16.5714134, 80.6818557, 6944],
  [16.5463536, 80.6483696, 6944],
  [16.5195944, 80.6875634, 6957],
  [16.5266108, 80.6507268, 6957],
  [16.5193543, 80.6840121, 6982],
  [16.474876, 80.605606, 7000],
  [16.5069461, 80.6673711, 7020],
  [16.4944613, 80.6652908, 7108],
  [16.5311839, 80.638935, 7190],
  [16.5061743, 80.6480153, 7194],
  [16.52001478, 80.62279709, 7222],
  [16.479619, 80.5986106, 7222],
  [16.538803, 80.64017066, 7222],
  [16.478934, 80.690521, 7222],
  [16.5088669, 80.6451779, 7352],
  [16.4575524, 80.7400488, 7366],
  [16.5193543, 80.6840121, 7372],
  [16.4944613, 80.6652908, 7407],
  [16.4997252, 80.6560636, 7447],
  [16.5088669, 80.6451779, 7500],
  [16.517205, 80.681306, 7571],
  [16.4944613, 80.6652908, 7600],
  [16.5088669, 80.6451779, 7600],
  [16.5283487, 80.7941356, 7632],
  [16.884957, 80.160679, 7656],
  [16.604589, 80.619575, 7716],
  [16.5513305, 80.654154, 7716],
  [16.52633, 80.6042897, 7745],
  [16.5147782, 80.6226318, 7778],
  [16.4919953, 80.6590494, 7800],
  [16.4821909, 80.7006496, 7812],
  [16.4821909, 80.7006496, 7826],
  [16.54118, 80.5783809, 7829],
  [16.5069461, 80.6673711, 7857],
  [16.4267618, 80.5774534, 7922],
  [16.4944613, 80.6652908, 7941],
  [16.5189221, 80.6337322, 8000],
  [16.5099088, 80.6714597, 8000],
  [16.4337801, 80.7678633, 8000],
  [16.453341, 80.607955, 8019],
  [16.523425, 80.775476, 8032],
  [16.5088669, 80.6451779, 8073],
  [16.514075, 80.6313041, 8144],
  [16.5463536, 80.6483696, 8148],
  [16.478934, 80.690521, 8167],
  [16.532511, 80.64256, 8182],
  [16.4997252, 80.6560636, 8273],
  [16.4997252, 80.6560636, 8273],
  [16.4997252, 80.6560636, 8273],
  [16.4997252, 80.6560636, 8273],
  [16.4997252, 80.6560636, 8273],
  [16.4997252, 80.6560636, 8273],
  [16.4997252, 80.6560636, 8273],
  [16.4997252, 80.6560636, 8273],
  [16.4997252, 80.6560636, 8273],
  [16.4997252, 80.6560636, 8273],
  [16.4997252, 80.6560636, 8273],
  [16.512848, 80.701085, 8307],
  [16.54118, 80.5783809, 8316],
  [16.527059, 80.598294, 8333],
  [16.5193543, 80.6840121, 8333],
  [16.540273, 80.635955, 8333],
  [16.5193543, 80.6840121, 8333],
  [16.4575524, 80.7400488, 8354],
  [16.4822628, 80.6623603, 8357],
  [16.54176125, 80.62956382, 8444],
  [16.4267618, 80.5774534, 8476],
  [16.5283487, 80.7941356, 8547],
  [16.4905671, 80.6923312, 8658],
  [16.5513305, 80.654154, 8667],
  [16.52633, 80.6042897, 8696],
  [16.5049539, 80.6229787, 8701],
  [16.479619, 80.5986106, 8727],
  [16.521976, 80.6319316, 8738],
  [16.5061743, 80.6480153, 8788],
  [16.5061743, 80.6480153, 8846],
  [16.479619, 80.5986106, 8861],
  [16.5311839, 80.638935, 8889],
  [16.54118, 80.5783809, 8889],
  [16.46816, 80.719534, 8889],
  [16.527059, 80.598294, 8900],
  [16.4997252, 80.6560636, 9028],
  [16.51577734, 80.60770092, 9028],
  [16.4821909, 80.7006496, 9059],
  [16.5513305, 80.654154, 9111],
  [16.5513305, 80.654154, 9111],
  [16.478934, 80.690521, 9183],
  [16.474876, 80.605606, 9189],
  [16.4267618, 80.5774534, 9214],
  [16.4956499, 80.6632752, 9246],
  [16.5061743, 80.6480153, 9259],
  [16.5069461, 80.6673711, 9319],
  [16.4267618, 80.5774534, 9333],
  [16.478934, 80.690521, 9390],
  [16.5061743, 80.6480153, 9523],
  [16.5415147, 80.6417097, 9524],
  [16.4267618, 80.5774534, 9579],
  [16.7730685, 80.267503, 9636],
  [16.527059, 80.598294, 9750],
  [16.4944613, 80.6652908, 9774],
  [16.5074896, 80.6812287, 9850],
  [16.483586, 80.672972, 9862],
  [16.479619, 80.5986106, 9909],
  [16.51209475, 80.63794738, 10000],
  [16.5889686, 80.521422, 10000],
  [16.5188835, 80.6207237, 10000],
  [16.5283487, 80.7941356, 10000],
  [16.5188835, 80.6207237, 10000],
  [16.506194, 80.645219, 10000],
  [16.5134135, 80.6652908, 10000],
  [16.4919953, 80.6590494, 10000],
  [16.4905671, 80.6923312, 10001],
  [16.527059, 80.598294, 10008],
  [16.70674, 81.00677, 10036],
  [16.52633, 80.6042897, 10152],
  [16.5188835, 80.6207237, 10159],
  [16.5188835, 80.6207237, 10159],
  [16.7730685, 80.267503, 10256],
  [16.5283487, 80.7941356, 10270],
  [16.524988, 80.6146524, 10288],
  [16.479619, 80.5986106, 10303],
  [16.5099088, 80.6714597, 10364],
  [16.524988, 80.6146524, 10370],
  [16.5121689, 80.6375476, 10392],
  [16.488238, 80.654882, 10394],
  [16.5099088, 80.6714597, 10417],
  [16.5266108, 80.6507268, 10458],
  [16.499589, 80.677748, 10500],
  [16.483373, 80.6618234, 10500],
  [16.4997252, 80.6560636, 10511],
  [16.5283487, 80.7941356, 10526],
  [16.524988, 80.6146524, 10612],
  [16.5040446, 80.6514204, 10833],
  [16.4915329, 80.6000794, 10992],
  [16.54118, 80.5783809, 11111],
  [16.521976, 80.6319316, 11111],
  [16.478934, 80.690521, 11111],
  [16.5049539, 80.6229787, 11111],
  [16.5286537, 80.6313041, 11197],
  [16.5069461, 80.6673711, 11200],
  [16.367497, 80.843539, 11333],
  [16.514075, 80.6313041, 11500],
  [16.5356484, 80.5924449, 11521],
  [16.54118, 80.5783809, 11649],
  [16.5274425, 80.6408426, 11696],
  [16.521976, 80.6319316, 11719],
  [16.5061743, 80.6480153, 11785],
  [16.5061743, 80.6480153, 12000],
  [16.367497, 80.843539, 12000],
  [16.5142496, 80.6514204, 12000],
  [16.5061743, 80.6480153, 12012],
  [16.4915329, 80.6000794, 12222],
  [16.524988, 80.6146524, 12346],
  [16.524988, 80.6146524, 12346],
  [16.524988, 80.6146524, 12346],
  [16.524988, 80.6146524, 12346],
  [16.524988, 80.6146524, 12346],
  [16.524988, 80.6146524, 12346],
  [16.524988, 80.6146524, 12346],
  [16.524988, 80.6146524, 12346],
  [16.524988, 80.6146524, 12346],
  [16.524988, 80.6146524, 12346],
  [16.5206918, 80.6406692, 12469],
  [16.54118, 80.5783809, 12666],
  [16.4862642, 80.6857453, 12809],
  [16.540273, 80.635955, 12931],
  [16.5283487, 80.7941356, 13000],
  [16.367497, 80.843539, 13000],
  [16.5283487, 80.7941356, 13333],
  [16.5188835, 80.6207237, 13333],
  [16.510478, 80.659133, 13333],
  [16.524988, 80.6146524, 13333],
  [16.5188835, 80.6207237, 13333],
  [16.483586, 80.672972, 13611],
  [16.4822628, 80.6623603, 13776],
  [16.527059, 80.598294, 13889],
  [16.527059, 80.598294, 14000],
  [16.5197179, 80.6238261, 14166],
  [16.502393, 80.655235, 14198],
  [16.5027866, 80.6396287, 14615],
  [16.5266108, 80.6507268, 14840],
  [17.0084792, 80.3759106, 15127],
  [16.52633, 80.6042897, 15152],
  [16.527059, 80.598294, 15179],
  [16.5061743, 80.6480153, 15406],
  [16.5366511, 80.6146524, 15873],
  [16.50397252, 80.65066146, 15987],
  [16.377253, 80.837067, 16000],
  [16.377253, 80.837067, 16000],
  [16.377253, 80.837067, 16000],
  [16.377253, 80.837067, 16000],
  [16.377253, 80.837067, 16000],
  [16.377253, 80.837067, 16000],
  [16.377253, 80.837067, 16000],
  [16.377253, 80.837067, 16000],
  [16.377253, 80.837067, 16000],
  [16.5889686, 80.521422, 16000],
  [16.377253, 80.837067, 16000],
  [16.5105301, 80.7477708, 16393],
  [16.506194, 80.645219, 16461],
  [16.54118, 80.5783809, 16500],
  [16.54118, 80.5783809, 16500],
  [16.54118, 80.5783809, 16500],
  [16.54118, 80.5783809, 16500],
  [16.54118, 80.5783809, 16500],
  [16.54118, 80.5783809, 16500],
  [16.54118, 80.5783809, 16500],
  [16.54118, 80.5783809, 16500],
  [16.54118, 80.5783809, 16500],
  [16.54118, 80.5783809, 16500],
  [16.5061743, 80.6480153, 16666],
  [16.6837219, 80.3955449, 16667],
  [16.527059, 80.598294, 17429],
  [16.4977172305877, 80.6545350343677, 17500],
  [16.521976, 80.6319316, 17833],
  [16.6837219, 80.3955449, 18000],
  [16.4337801, 80.7678633, 18047],
  [16.4337801, 80.7678633, 18047],
  [16.4337801, 80.7678633, 18047],
  [16.4337801, 80.7678633, 18047],
  [16.4337801, 80.7678633, 18047],
  [16.4337801, 80.7678633, 18047],
  [16.4337801, 80.7678633, 18047],
  [16.4337801, 80.7678633, 18047],
  [16.4337801, 80.7678633, 18047],
  [16.4337801, 80.7678633, 18047],
  [17.0084792, 80.3759106, 18141],
  [16.5283487, 80.7941356, 18333],
  [16.544193984014324, 80.80540486148146, 18797],
  [16.5847244, 80.5174502, 19444],
  [16.5055493, 80.65220301, 19500],
  [16.5055493, 80.65220301, 19500],
  [16.5055493, 80.65220301, 19500],
  [16.5055493, 80.65220301, 19500],
  [16.5055493, 80.65220301, 19500],
  [16.5055493, 80.65220301, 19500],
  [16.5055493, 80.65220301, 19500],
  [16.5055493, 80.65220301, 19500],
  [16.5055493, 80.65220301, 19500],
  [16.501635, 80.649683, 19500],
  [16.5055493, 80.65220301, 19500],
  [16.5489578, 80.5966093, 21000],
  [16.5061743, 80.6480153, 21000],
  [16.4821909, 80.7006496, 21700],
  [16.510155, 80.667452, 21739],
  [16.4997252, 80.6560636, 22222],
  [16.4997252, 80.6560636, 22222],
  [16.4821909, 80.7006496, 22735],
  [16.5193543, 80.6840121, 24044],
  [16.583068, 80.8920773, 24561],
  [16.5140232, 80.6139585, 25000],
  [16.4267618, 80.5774534, 26000],
  [16.638506, 80.970529, 26012],
  [16.5714134, 80.6818557, 27343],
  [16.5061743, 80.6480153, 27407],
  [16.5121689, 80.6375476, 27778],
  [16.508583, 80.6642443, 28637],
  [16.568618, 80.545502, 29149],
  [16.5061743, 80.6480153, 30000],
  [16.5240791, 80.6770277, 32000],
  [16.5193543, 80.6840121, 32000],
  [16.4821909, 80.7006496, 32000],
  [16.568618, 80.545502, 33113],
  [16.5105301, 80.7477708, 37267],
  [16.442948, 80.751545, 38000],
  [16.512848, 80.701085, 40000],
  [16.54118, 80.5783809, 42500],
  [16.322985, 80.961208, 45455],
  [16.5415147, 80.6417097, 48485],
  [16.538803, 80.64017066, 48872],
  [16.4822628, 80.6623603, 50349],
  [16.5415147, 80.6417097, 50857],
  [16.5266108, 80.6507268, 53000],
  [16.7730685, 80.267503, 56584],
  [16.5061743, 80.6480153, 57142],
  [16.4940731, 80.6097579, 58065],
  [16.4821909, 80.7006496, 58594],
  [16.4821909, 80.7006496, 60737],
  [16.4828392, 80.775969, 61667],
  [16.4944613, 80.6652908, 63429],
  [16.367497, 80.843539, 64815],
  [16.54118, 80.5783809, 65000],
  [16.52001478, 80.62279709, 68085],
  [16.54159299, 80.60639796, 70847],
  [16.5415147, 80.6417097, 73770],
  [16.538803, 80.64017066, 74286],
  [16.437719, 80.740414, 75000],
  [16.4862642, 80.6857453, 75000],
  [16.367497, 80.843539, 85000],
  [16.527059, 80.598294, 110000],
  [16.4862642, 80.6857453, 115277],
  [16.4997252, 80.6560636, 119318],
  [16.5206918, 80.6406692, 130000],
  [16.4905671, 80.6923312, 158823],
  [16.478934, 80.690521, 396786],
  [16.5105301, 80.7477708, 440000],
  [16.5889686, 80.521422, 1500000],
  [16.7730685, 80.267503, 3250000],
  [16.5714134, 80.6818557, 4300000],
  [16.5283487, 80.7941356, 5833333],
  [16.638506, 80.970529, 10000000],
  [16.5283487, 80.7941356, 50000000],
];

/**
 * Cities Restaurants Data
 */
export const CitiesRestaurantsData = {
  [CitiesBBox["city-kozhikode"]]: {
    statusCode: 200,
    result: {
      type: "restaurant",
      points: [...kozhikodePoints, ...kozhikodePoints], // doubling for better heatmap
      stats: {
        max: 32000,
        min: 3,
        property: "cost-for-two",
        percentiles: {
          5: 149,
          10: 390,
          15: 765,
          20: 1156,
          25: 1554,
          30: 2004,
          35: 2551,
          40: 2975,
          45: 3504,
          50: 4000,
          55: 4298,
          60: 4592,
          65: 5297,
          70: 6000,
          75: 6471,
          80: 7083,
          85: 7954,
          90: 8838,
          95: 11011,
        },
      },
    },
  },
  [CitiesBBox["city-hubli"]]: {
    statusCode: 200,
    result: {
      type: "restaurant",
      points: [...hubliPoints, ...hubliPoints], // doubling for better heatmap
      stats: {
        max: 1250000,
        min: 24,
        property: "cost-for-two",
        percentiles: {
          5: 680,
          10: 1367,
          15: 1795,
          20: 2101,
          25: 2607,
          30: 2912,
          35: 3087,
          40: 3500,
          45: 3750,
          50: 4143,
          55: 4579,
          60: 5062,
          65: 5447,
          70: 6006,
          75: 6928,
          80: 7792,
          85: 8765,
          90: 10116,
          95: 14902,
        },
      },
    },
  },
  [CitiesBBox["city-vijayawada"]]: {
    statusCode: 200,
    result: {
      type: "restaurant",
      points: [...vijayawadaPoints, ...vijayawadaPoints], // doubling for better heatmap
      stats: {
        max: 50000000,
        min: 9,
        property: "cost-for-two",
        percentiles: {
          5: 556,
          10: 1333,
          15: 1657,
          20: 1928,
          25: 2273,
          30: 2778,
          35: 3006,
          40: 3381,
          45: 3686,
          50: 3992,
          55: 4167,
          60: 4430,
          65: 4780,
          70: 5139,
          75: 5764,
          80: 6818,
          85: 8664,
          90: 11807,
          95: 18047,
        },
      },
    },
  },
};
